// Azerbaijani translations
export const az: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'İdarə paneli',
  'menu.orderNew': 'Yeni sifariş',
  'menu.deliveryList': 'Çatdırılma siyahısı',
  'menu.delivery': 'Çatdırılma',
  'menu.receipt': 'Qəbzi çap et',
  
  // Definitions
  'menu.definitions': 'Təriflər',
  'menu.customers': 'Müştərilər',
  'menu.products': 'Məhsul tərifləri',
  'menu.pricing': 'Qiymət tərifləri',
  'menu.tailoring': 'Dərzilik',
  'menu.attributes': 'Məhsul xüsusiyyətləri',
  'menu.users': 'İstifadəçilər',
  'menu.productOrdering': 'Məhsul sıralaması',
  'menu.discounts': 'Endirim tərifləri',
  
  // Settings
  'menu.settings': 'Parametrlər',
  'menu.generalSettings': 'Ümumi parametrlər',
  'menu.permissions': 'İcazə idarəsi',
  'menu.subscription': 'Abunəlik',
  'menu.invoices': 'Faktura idarəsi',
  'menu.expenses': 'Xərclər',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Hesabatlar və Mühasibat',
  'menu.systemAndCommunication': 'Sistem və Kommunikasiya',
  'menu.reportsList': 'Qəbz siyahısı',
  'menu.accountStatement': 'Hesab çıxarışı',
  'menu.tickets': 'Dəstək biletləri',
  'menu.support': 'Dəstək',
  'menu.profile': 'Profil',
  'menu.logout': 'Çıxış',
  'menu.notifications': 'SMS/WhatsApp bildirişləri',
  'menu.whatsappConnection': 'WhatsApp bağlantısı',
  'menu.smsConnection': 'SMS bağlantısı',
  
  // Dashboard
  'dashboard.title': 'İdarə paneli',
  'dashboard.todaySales': 'Bu günkü satışlar',
  'dashboard.totalOrders': 'Ümumi sifarişlər',
  'dashboard.pendingDeliveries': 'Gözləyən çatdırılmalar',
  'dashboard.activeCustomers': 'Aktiv müştərilər',
  'dashboard.recentOrders': 'Son sifarişlər',
  'dashboard.viewAll': 'Hamısına bax',
  'dashboard.quickActions': 'Sürətli əməliyyatlar',
  'dashboard.newOrder': 'Yeni sifariş',
  'dashboard.newCustomer': 'Yeni müştəri',
  'dashboard.deliveries': 'Çatdırılmalar',
  'dashboard.reports': 'Hesabatlar',
  'dashboard.today': 'Bu gün',
  'dashboard.yesterday': 'Dünən',
  'dashboard.week': 'Həftə',
  'dashboard.month': 'Ay',
  'dashboard.quarter': 'Rüb',
  'dashboard.year': 'İl',
  'dashboard.totalRevenue': 'Ümumi gəlir',
  'dashboard.totalPieces': 'Ümumi ədəd',
  'dashboard.cancelled': 'Ləğv edilib',
  'dashboard.inProcess': 'İşlənir',
  'dashboard.inProcessDesc': 'İşlənən sifarişlər',
  'dashboard.ready': 'Hazırdır',
  'dashboard.readyDesc': 'Çatdırılmağa hazırdır',
  'dashboard.delivered': 'Çatdırılıb',
  'dashboard.deliveredDesc': 'Tamamlanmış sifarişlər',
  'dashboard.announcements': 'Elanlar',
  'dashboard.announcementAll': 'Ümumi',
  'dashboard.announcementPrivate': 'Şəxsi',
  
  // Service Types
  'service.tailor': 'Dərzi',
  'service.dryCleaning': 'Quru təmizləmə',
  'service.washing': 'Yuma',
  'service.ironing': 'Ütüləmə',
  'service.dyeing': 'Boyama',
  'service.shoeShine': 'Ayaqqabı cilalanması',
  'service.carpet': 'Xalça',
  'service.tailoring': 'Dərzilik təmiri',
  'service.carpetWashing': 'Xalça yuması',
  'service.selectService': 'Xidmət seç',
  'service.addToCart': 'Səbətə əlavə et',
  'service.total': 'Cəmi',
  
  // Order Create Page
  'orderCreate.cart': 'Səbət',
  'orderCreate.totalPieces': 'Ümumi ədəd',
  'orderCreate.plannedDelivery': 'Planlaşdırılmış çatdırılma',
  'orderCreate.payment': 'Ödəniş',
  'orderCreate.save': 'Yadda saxla',
  'orderCreate.allCategories': 'Hamısı',
  'orderCreate.selectCustomer': 'Müştəri seç',
  'orderCreate.selectCustomerPlaceholder': 'Müştəri seç',
  'orderCreate.change': 'Dəyişdir',
  'orderCreate.select': 'Seç',
  'orderCreate.balance': 'Balans',
  'orderCreate.searchCustomer': 'Ad, telefon və ya ünvana görə axtar... (misal: john+5551234567)',
  'orderCreate.newCustomer': 'Yeni müştəri',
  'orderCreate.customerName': 'Ad Soyad',
  'orderCreate.customerPhone': 'Telefon',
  'orderCreate.customerEmail': 'E-poçt',
  'orderCreate.customerAddress': 'Ünvan',
  'orderCreate.addCustomer': 'Müştəri əlavə et',
  'orderCreate.customer': 'Müştəri',
  'orderCreate.serviceType': 'Xidmət növü',
  'orderCreate.clickToSelect': 'Seçmək üçün klikləyin',
  'orderCreate.deliveryDate': 'Çatdırılma tarixi',
  'orderCreate.details': 'Təfərrüatlar',
  'orderCreate.itemDetails': 'Məhsul təfərrüatları',
  'orderCreate.tailoringOperations': 'Dərzilik əməliyyatları',
  'orderCreate.tailoringTitle': 'Dərzilik əməliyyatları',
  'orderCreate.discount': 'Endirim',
  'orderCreate.discountLabel': 'Endirim (%)',
  'orderCreate.debt': 'Borc',
  'orderCreate.credit': 'Kredit',
  'orderCreate.homeDelivery': 'Evə çatdırılma',
  'orderCreate.homeDeliveryAddress': 'Ünvan',
  'orderCreate.addressRequired': 'Ünvan tələb olunur!',
  'orderCreate.subtotal': 'Ara cəm',
  'orderCreate.grandTotal': 'Ümumi cəm',
  
  // Products
  'products.title': 'Məhsul tərifləri',
  'products.addNew': 'Yeni məhsul',
  'products.category': 'Kateqoriya',
  'products.name': 'Məhsul adı',
  'products.price': 'Qiymət',
  'products.color': 'Rəng',
  'products.active': 'Aktiv',
  'products.actions': 'Əməliyyatlar',
  'products.search': 'Məhsul axtar...',
  'products.noProducts': 'Məhsul tapılmadı',
  'products.noCategoryProducts': 'Bu kateqoriyada məhsul tapılmadı',
  'products.emptyCart': 'Səbət boşdur',
  
  // Customers
  'customers.title': 'Müştərilər',
  'customers.addNew': 'Yeni müştəri',
  'customers.search': 'Müştəri axtar...',
  'customers.name': 'Ad',
  'customers.phone': 'Telefon',
  'customers.email': 'E-poçt',
  'customers.address': 'Ünvan',
  'customers.balance': 'Balans',
  'customers.actions': 'Əməliyyatlar',
  'customers.edit': 'Redaktə et',
  'customers.delete': 'Sil',
  'customers.noCustomers': 'Müştəri tapılmadı',
  'customers.tableCustomer': 'Müştəri',
  'customers.tableContact': 'Əlaqə',
  'customers.tableAddress': 'Ünvan',
  'customers.tableNotifications': 'Bildirişlər',
  'customers.tableBalance': 'Balans',
  'customers.tableActions': 'Əməliyyatlar',
  'customers.totalCount': 'Cəmi {count} müştəri',
  'customers.notes': 'Qeyd',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Ad, telefon, e-poçt və ya ünvana görə axtar... (misal: john+5551234567)',
  'customers.updated': 'Müştəri yeniləndi',
  'customers.updateError': 'Müştəri yenilənməsində xəta',
  'customers.added': 'Müştəri əlavə edildi',
  'customers.addError': 'Müştəri əlavə edilməsində xəta',
  'customers.deleted': 'Müştəri silindi',
  'customers.deleteError': 'Müştəri silinməsində xəta',
  'customers.deleteConfirm': '"{name}" müştərisini silmək istədiyinizə əminsiniz?',
  'customers.loadError': 'Müştərilər yüklənməsində xəta',
  'customers.noResults': 'Nəticə tapılmadı',
  'customers.showingFirst50': 'İlk 50 nəticə göstərilir',
  'customers.totalResults': 'cəmi',
  
  // Users
  'users.title': 'İstifadəçilər',
  'users.addNew': 'Yeni istifadəçi',
  'users.name': 'Ad Soyad',
  'users.email': 'E-poçt',
  'users.role': 'Rol',
  'users.pin': 'PIN',
  'users.permissions': 'İcazələr',
  'users.allPermissions': 'Bütün icazələr',
  'users.permissionCount': '{count} icazə',
  'users.changePin': 'PIN-i dəyişdir',
  'users.edit': 'Redaktə et',
  'users.newUser': 'Yeni istifadəçi',
  'users.editUser': 'İstifadəçini redaktə et',
  'users.editingUser': '{name} istifadəçisi redaktə edilir',
  'users.pinCode': 'PIN kodu (4-6 rəqəm)',
  'users.selectRole': 'Rol seç',
  'users.patron': 'Sahibkar',
  'users.kasiyer': 'Kassir',
  'users.sofor': 'Sürücü',
  'users.changePinTitle': 'PIN kodunu dəyişdir',
  'users.newPin': 'Yeni PIN kodu',
  'users.confirmPin': 'PIN-i təsdiqlə',
  'users.pinMismatch': 'PIN kodları uyğun gəlmir',
  'users.pinRequired': 'PIN kodu tələb olunur',
  'users.pinLength': 'PIN kodu 4-6 rəqəm olmalıdır',
  'users.changingPinFor': '{name} üçün PIN kodu dəyişdirilir',
  
  // Pricing Page
  'pricing.title': 'Qiymət tərifləri',
  'pricing.search': 'Məhsul axtar...',
  'pricing.product': 'Məhsul',
  'pricing.dryCleaning': 'Quru təmizləmə',
  'pricing.washing': 'Yuma',
  'pricing.ironing': 'Ütüləmə',
  'pricing.dyeing': 'Boyama',
  'pricing.tailoring': 'Dərzilik təmiri',
  'pricing.shoeShine': 'Ayaqqabı cilalanması',
  'pricing.action': 'Əməliyyat',
  'pricing.save': 'Yadda saxla',
  'pricing.saving': 'Yadda saxlanılır',
  'pricing.pricesSaved': 'Qiymətlər yadda saxlanıldı',
  'pricing.pricesSaveError': 'Qiymətlərin yadda saxlanmasında xəta',
  'pricing.noProducts': 'Məhsul tapılmadı',
  'pricing.loadError': 'Məhsulların yüklənməsində xəta',
  
  // Tailoring Page
  'tailoring.title': 'Dərzilik əməliyyatları',
  'tailoring.addNew': 'Yeni əməliyyat',
  
  // Attributes Page
  'attributes.title': 'Məhsul xüsusiyyətləri',
  'attributes.colors': 'Rənglər',
  'attributes.stains': 'Ləkə növləri',
  'attributes.damages': 'Zədə növləri',
  'attributes.add': 'Əlavə et',
  
  // Permissions Page
  'permissions.title': 'İcazə idarəsi',
  'permissions.subtitle': 'Sahibkar və kassir rolları üçün icazələri təyin edin',
  'permissions.about': 'İcazə idarəsi haqqında',
  'permissions.patronInfo': '<strong>Sahibkar:</strong> Bütün sistem icazələri olan əsas administrator rolu.',
  'permissions.cashierInfo': '<strong>Kassir:</strong> Gündəlik əməliyyatlar üçün məhdud icazələri olan istifadəçi rolu.',
  'permissions.saveSuccess': 'İcazələr yadda saxlanıldı',
  'permissions.saveError': 'İcazələrin yadda saxlanmasında xəta',
  'permissions.patron': 'Sahibkar',
  'permissions.cashier': 'Kassir',
  'permissions.patronRole': 'Tam administrator girişi',
  'permissions.cashierRole': 'Məhdud istifadəçi girişi',
  'permissions.activePermissions': 'Aktiv icazələr:',
  'permissions.selectAllPatron': 'Sahibkar üçün hamısını seç',
  'permissions.deselectAllPatron': 'Sahibkar üçün hamısını ləğv et',
  'permissions.selectAllCashier': 'Kassir üçün hamısını seç',
  'permissions.deselectAllCashier': 'Kassir üçün hamısını ləğv et',
  'permissions.saving': 'Yadda saxlanılır...',
  'permissions.permissionList': 'İcazə siyahısı',
  'permissions.infoTitle': 'İcazə idarəsi haqqında',
  'permissions.infoText1': 'Bütün sistem icazələri olan əsas administrator rolu.',
  'permissions.infoText2': 'Gündəlik əməliyyatlar üçün məhdud icazələri olan istifadəçi rolu.',
  'permissions.infoText3': 'Dəyişikliklər yadda saxlanılana qədər təsirli olmayacaq.',
  'permissions.infoText4': 'İcazələr hər rol üçün fərdiləşdirilə bilər.',
  
  // Driver Dashboard Page
  'driver.title': 'Sürücü paneli',
  'driver.todayRevenue': 'Bu günkü gəlir',
  'driver.totalPieces': 'Ümumi ədəd',
  'driver.pending': 'Gözləyir',
  'driver.ready': 'Hazırdır',
  'driver.pickup': 'Götürülmə',
  'driver.delivery': 'Çatdırılma',
  
  // Subscription Page
  'subscription.title': 'Abunəlik və ödəniş',
  'subscription.invoiceManagement': 'Faktura idarəsi',
  
  // Invoices Page
  'invoices.title': 'Faktura idarəsi',
  'invoices.subtitle': 'Abunəlik fakturalarınıza baxın və endirin',
  
  // Expenses Page
  'expenses.title': 'Xərc girişi',
  'expenses.addNew': 'Yeni xərc',
  'expenses.total': 'Ümumi xərclər',
  'expenses.totalToday': 'Bu günkü ümumi xərclər',
  'expenses.deletePermission': 'ℹ️ Xərclərin silinməsi yalnız sahibkar rolu üçün icazəlidir.',
  'expenses.description': 'Təsvir',
  'expenses.amount': 'Məbləğ',
  'expenses.category': 'Kateqoriya',
  'expenses.noExpenses': 'Bu gün xərc qeydi yoxdur',
  'expenses.newExpense': 'Yeni xərc',
  'expenses.descriptionLabel': 'Təsvir *',
  'expenses.amountLabel': 'Məbləğ *',
  'expenses.categoryLabel': 'Kateqoriya *',
  'expenses.categoryPlaceholder': 'Kateqoriya seç...',
  'expenses.deleteTitle': 'Xərci sil',
  'expenses.deleteConfirm': 'Bu xərci silmək istədiyinizə əminsiniz?',
  'expenses.descriptionField': 'Təsvir:',
  'expenses.categoryField': 'Kateqoriya:',
  'expenses.amountField': 'Məbləğ:',
  'expenses.dateField': 'Tarix:',
  'expenses.cancel': 'Ləğv et',
  'expenses.yesDelete': 'Bəli, sil',
  'expenses.deleting': 'Silinir...',
  'expenses.saved': 'Xərc yadda saxlanıldı',
  'expenses.saveError': 'Xərcin yadda saxlanmasında xəta',
  'expenses.deleted': 'Xərc silindi',
  'expenses.deleteError': 'Xərcin silinməsində xəta',
  'expenses.loadError': 'Xərclərin yüklənməsində xəta',
  'expenses.dateFilter': 'Tarix filtri',
  'expenses.showDateFilter': 'Tarix aralığı seç',
  'expenses.startDate': 'Başlama tarixi',
  'expenses.endDate': 'Bitmə tarixi',
  'expenses.applyFilter': 'Filtrləşdir',
  'expenses.clearFilter': 'Təmizlə',
  'expenses.activeFilter': 'Aktiv filtr',
  'expenses.filterApplied': 'Tarix filtri tətbiq edildi',
  'expenses.filterCleared': 'Filtr təmizləndi',
  'expenses.selectBothDates': 'Zəhmət olmasa başlama və bitmə tarixlərini seçin',
  
  // Delivery List Page
  'deliveryList.title': 'Çatdırılma siyahısı',
  'deliveryList.search': 'Qəbz nömrəsi, müştəri adı və ya telefon...',
  'deliveryList.all': 'Hamısı',
  'deliveryList.pending': 'Gözləyir',
  'deliveryList.ready': 'Hazırdır',
  'deliveryList.date': 'Tarix',
  'deliveryList.pieces': 'Ədəd',
  'deliveryList.amount': 'Məbləğ',
  'deliveryList.readyButton': 'Hazırdır',
  'deliveryList.receiptButton': 'Qəbz',
  'deliveryList.noOrders': 'Sifariş tapılmadı',
  'deliveryList.statusUpdated': 'Sifariş hazır olaraq qeyd edildi',
  'deliveryList.statusUpdateError': 'Statusun yenilənməsində xəta',
  'deliveryList.loadError': 'Sifarişlərin yüklənməsində xəta',
  'deliveryList.whatsappSending': '📱 WhatsApp mesajı göndərilir...',
  'deliveryList.smsSent': '📨 SMS mesajı göndərildi',
  
  // Delivery Page
  'deliveryPage.title': 'Çatdırılma',
  'deliveryPage.search': 'Qəbz nömrəsi, ad, telefon və ya ünvana görə axtar...',
  'deliveryPage.pieces': 'Ədəd',
  'deliveryPage.amount': 'Məbləğ',
  'deliveryPage.payment': 'Ödəniş',
  'deliveryPage.deliverButton': 'Çatdır',
  'deliveryPage.noOrdersFound': 'Hazır sifariş tapılmadı',
  'deliveryPage.noReadyOrders': 'Çatdırılmağa hazır sifariş yoxdur',
  'deliveryPage.minSearchLength': 'Axtarmaq üçün ən azı 3 simvol daxil edin',
  'deliveryPage.paymentDialogTitle': 'Çatdırılmada ödəniş',
  'deliveryPage.ordersLoadError': 'Sifarişlərin yüklənməsində xəta',
  'deliveryPage.searchError': 'Axtarış xətası',
  'deliveryPage.deliverySuccess': 'Sifariş uğurla çatdırıldı',
  'deliveryPage.deliveryError': 'Çatdırılma xətası',
  'deliveryPage.whatsappSending': '📱 WhatsApp ilə qəbz göndərilir...',
  'deliveryPage.statusNotReady': 'Sifariş tapıldı, lakin çatdırılmağa hazır deyil',
  'deliveryPage.statusPending': 'Gözləyir - Əvvəlcə "Çatdırılma siyahısı" səhifəsindən hazır olaraq qeyd edin',
  'deliveryPage.statusDelivered': 'Çatdırıldı',
  'deliveryPage.statusCancelled': 'Ləğv edildi',
  'deliveryPage.receiptDelivered': '✅ *ÇATDIRILDı*',
  
  // Receipt Page
  'receipt.title': 'Qəbz və etiket',
  'receipt.customerReceipt': 'Müştəri qəbzi',
  'receipt.back': 'Geri',
  'receipt.print': 'Qəbzi çap et',
  'receipt.whatsappSend': 'WhatsApp göndər',
  'receipt.receiptNumber': 'Qəbz nömrəsi',
  'receipt.date': 'Tarix',
  'receipt.time': 'Vaxt',
  'receipt.product': 'Məhsul',
  'receipt.quantity': 'Miq',
  'receipt.price': 'Qiymət',
  'receipt.totalPieces': 'Ümumi ədəd',
  'receipt.subtotal': 'Ara cəm',
  'receipt.tax': 'ƏDV',
  'receipt.total': 'CƏMİ',
  'receipt.payment': 'Ödəniş',
  'receipt.plannedDelivery': 'Planlaşdırılmış çatdırılma',
  'receipt.notFound': 'Qəbz tapılmadı',
  'receipt.newOrder': 'Yeni sifariş',
  'receipt.search': 'Qəbz axtar və yenidən çap et',
  'receipt.searchPlaceholder': 'Qəbz nömrəsi, müştəri adı və ya telefon ilə axtar...',
  'receipt.searchEmpty': 'Axtarmaq üçün qəbz nömrəsi və ya müştəri adı daxil edin',
  'receipt.noResults': 'Nəticə tapılmadı',
  'receipt.resultsCount': '{count} nəticə tapıldı',
  'receipt.printButton': 'Qəbzi çap et',
  'receipt.products': 'məhsul',
  'receipt.loadError': 'Məlumatların yüklənməsində xəta',
  'receipt.whatsappOpening': 'WhatsApp açılır...',
  'receipt.labelPrinting': 'Etiket çap edilir {current}/{total}...',
  'receipt.andLabel': 'və etiket',
  'receipt.stain': 'Ləkə',
  'receipt.damage': 'Zədə',
  'receipt.taxPercent': 'ƏDV (%20)',
  'receipt.discount': 'Endirim',
  'receipt.discountedTotal': 'Endirimli cəm',
  'receipt.generalTotal': 'Ümumi cəm',
  'receipt.thankYou': 'Təşəkkürlər',
  'receipt.footerNote': 'Xoş günlər',
  'receipt.area': 'Sahə',
  'receipt.piece': 'ədəd',
  'receipt.homeDelivery': 'Evə çatdırılma',
  'receipt.addressLabel': 'Ünvan',
  
  // Payment
  'payment.method': 'Ödəniş üsulu',
  'payment.cash': 'Nağd',
  'payment.creditCard': 'Kredit kartı (POS)',
  'payment.mealCard': 'Yemək kartı',
  'payment.account': 'Hesab',
  'payment.onDelivery': 'Çatdırılmada',
  'payment.bankTransfer': 'Bank köçürməsi',
  'payment.selectMethod': 'Ödəniş üsulu seç',
  'payment.amount': 'Ödəniş məbləği',
  'payment.amountToPay': 'Ödəniləcək məbləğ',
  'payment.paid': 'Ödənilib',
  'payment.remaining': 'Qalan',
  'payment.complete': 'Ödənişi tamamla',
  'payment.confirm': 'Ödənişi təsdiqlə',
  'payment.posPayment': 'Kredit kartı ödənişi (POS cihazı)',
  'payment.posInstructions': 'Zəhmət olmasa POS cihazından müştəridən ödəniş alın.',
  'payment.posConfirm': 'POS cihazından ödəniş təsdiqini aldıqdan sonra "Təsdiqlə" düyməsinə basın.',
  'payment.success': 'Ödəniş uğurlu oldu',
  'payment.failed': 'Ödəniş uğursuz oldu',
  'payment.splitPayment': 'Bölünmüş ödəniş',
  'payment.addPayment': 'Ödəniş əlavə et',
  'payment.status': 'Ödəniş statusu',
  'payment.pending': 'Gözləyir',
  'payment.completed': 'Tamamlandı',
  'payment.partial': 'Qismən ödəniş',
  
  // WhatsApp Messages
  'whatsapp.orderReady': 'Sifarişiniz hazırdır! 🎉',
  'whatsapp.receiptMessage': 'Hörmətli {customerName}, {orderNumber} sifarişiniz hazırdır və çatdırılma gözləyir.',
  'whatsapp.deliveryReminder': '{customerName}, {orderNumber} sifarişinizi {daysAgo} gündür götürməmisiniz. Zəhmət olmasa ən qısa zamanda götürün.',
  'whatsapp.thankYou': 'Təşəkkürlər!',
  
  // Settings Page
  'settings.title': 'Parametrlər',
  'settings.general': 'Ümumi parametrlər',
  'settings.companyName': 'Şirkət adı',
  'settings.language': 'Dil',
  'settings.currency': 'Valyuta',
  'settings.currencyPosition': 'Valyuta mövqeyi',
  'settings.currencyPositionLeft': 'Sol ($100.00)',
  'settings.currencyPositionRight': 'Sağ (100.00₺)',
  'settings.currencyPositionPreviewLeft': 'Simvol solda',
  'settings.currencyPositionPreviewRight': 'Simvol sağda',
  'settings.numberFormat': 'Nömrə formatı',
  'settings.currencyFormat': 'Valyuta formatı',
  'settings.showDecimals': 'Onluqları göstər',
  'settings.showDecimalsDesc': 'Qiymətlərdə onluq hissəni (qəpikləri) göstər',
  'settings.dateFormat': 'Tarix formatı',
  'settings.deliveryDays': 'Çatdırılma müddəti (gün)',
  'settings.workOnSunday': 'Bazar günləri işlə',
  'settings.defaultServiceType': 'Varsayılan xidmət növü',
  'settings.defaultServiceTypeDesc': 'Məhsul giriş ekranı açıldığında avtomatik seçiləcək xidmət növü',
  'settings.defaultCategory': 'Varsayılan kateqoriya',
  'settings.defaultCategoryDesc': 'Məhsul giriş ekranı açıldığında avtomatik seçiləcək kateqoriya',
  'settings.companyLogo': 'Şirkət loqosu',
  'settings.logoDescription': 'Loqo qəbzlərdə və proqramın sol yuxarı hissəsində görünəcək. Tövsiyə olunan ölçü: 200x80px',
  'settings.uploadLogo': 'Loqo yüklə',
  'settings.removeLogo': 'Loqonu sil',
  'settings.noLogo': 'Loqo yoxdur',
  'settings.receiptSettings': 'Qəbz parametrləri',
  'settings.taxRate': 'Vergi dərəcəsi (%)',
  'settings.receiptFooterText': 'Qəbz alt mətni',
  'settings.receiptNote': 'Qəbz altlığı (qeydlər)',
  'settings.socialMedia': 'Sosial media və əlaqə',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Vebsayt',
  'settings.phone': 'Telefon',
  'settings.address': 'Ünvan',
  'settings.dangerZone': 'Təhlükəli zona',
  'settings.deleteDemoDataWarning': 'Demo məlumatları silmək bütün müştəri, sifariş, ödəniş və xərc qeydlərini siləcək.',
  'settings.productsWillBeKept': 'Məhsul tərifləri saxlanılacaq.',
  'settings.deleteDemoDataTitle': 'Demo məlumatlar silinəcək',
  'settings.deleteDemoDataConfirm': 'Bu əməliyyat geri qaytarıla bilməz! Bütün müştəri, sifariş, ödəniş və xərc qeydləri silinəcək.',
  'settings.areYouSure': 'Davam etmək istədiyinizə əminsiniz?',
  'settings.deleting': 'Silinir...',
  'settings.yesDelete': 'Bəli, sil',
  'settings.deleteDemoData': 'Demo məlumatları sil',
  'settings.save': 'Yadda saxla',
  'settings.loading': 'Yüklənir...',
  
  // Toasts
  'toast.settingsSaved': 'Parametrlər yadda saxlanıldı',
  'toast.settingsError': 'Parametrlərin yadda saxlanmasında xəta',
  'toast.settingsLoadError': 'Parametrlərin yüklənməsində xəta',
  'toast.logoUploaded': 'Loqo yükləndi. Yadda saxlamağı unutmayın!',
  'toast.logoRemoved': 'Loqo silindi. Yadda saxlamağı unutmayın!',
  'toast.logoSizeError': 'Loqo faylı 500KB-dan kiçik olmalıdır',
  'toast.logoTypeError': 'Yalnız şəkil faylları yüklənə bilər',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'WhatsApp bağlantısı',
  'whatsapp.subtitle': 'WhatsApp Business API bağlantınızı idarə edin',
  'whatsapp.connectionStatus': 'Bağlantı statusu',
  'whatsapp.disconnected': 'Bağlı deyil',
  'whatsapp.notConnectedMessage': 'WhatsApp hesabınız hələ bağlı deyil',
  'whatsapp.connectWithQR': 'QR kodu ilə bağlan',
  'whatsapp.importantInfo': 'Vacib məlumat',
  'whatsapp.info1': '1. Telefonunuzun WhatsApp tətbiqi ilə QR kodunu skan edin',
  'whatsapp.info2': '2. Bağlantıdan sonra avtomatik mesajlar göndərə bilərsiniz',
  'whatsapp.info3': '3. Bağlantını kəsmək üçün WhatsApp parametrlərindən çıxış edin',
  'whatsapp.info4': '4. QR kodu 60 saniyədən sonra avtomatik yenilənəcək',
  'whatsapp.generateQR': 'QR kodu yarat',
  
  // Common
  'common.yes': 'Bəli',
  'common.no': 'Xeyr',
  'common.cancel': 'Ləğv et',
  'common.confirm': 'Təsdiqlə',
  'common.delete': 'Sil',
  'common.edit': 'Redaktə et',
  'common.save': 'Yadda saxla',
  'common.search': 'Axtar',
  'common.loading': 'Yüklənir...',
  'common.noData': 'Məlumat yoxdur',
  'common.actions': 'Əməliyyatlar',
  'common.status': 'Status',
  'common.date': 'Tarix',
  'common.time': 'Vaxt',
  'common.total': 'Cəmi',
  'common.close': 'Bağla',
  'common.back': 'Geri',
  'common.submit': 'Göndər',
  'common.create': 'Yarat',
  'common.creating': 'Yaradılır...',
  'common.later': 'Sonra',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  
  // Tickets
  'tickets.title': 'Dəstək biletləri',
  'tickets.newTicket': 'Yeni bilet',
  'tickets.subject': 'Mövzu',
  'tickets.description': 'Təsvir',
  'tickets.status': 'Status',
  'tickets.createdAt': 'Yaradılıb',
  'tickets.open': 'Açıq',
  'tickets.inProgress': 'İşlənir',
  'tickets.closed': 'Bağlı',
  'tickets.sendMessage': 'Mesaj göndər',
  'tickets.closeTicket': 'Bileti bağla',
  'tickets.reopenTicket': 'Yenidən aç',
  'tickets.typeMessage': 'Mesajınızı yazın...',
  'tickets.noTickets': 'Hələ dəstək bileti yoxdur',
  'tickets.translate': 'Tərcümə et',
  'tickets.showOriginal': 'Orijinalı göstər',
  'tickets.translating': 'Tərcümə edilir...',
  'tickets.autoTranslate': 'Avto tərcümə',
  'tickets.translateTo': 'Tərcümə et:',
  'tickets.detectedLanguage': 'Aşkarlanmış dil',
  'tickets.translationEnabled': 'Avto tərcümə aktivləşdirildi',
  'tickets.translationDisabled': 'Avto tərcümə deaktivləşdirildi',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Quru təmizləmə idarə sistemi',
  'login.tenantId': 'Şirkət ID',
  'login.tenantPlaceholder': 'şirkət-id (misal: acme-clean)',
  'login.tenantIdHelp': 'Unikal şirkət identifikatorunuzu daxil edin',
  'login.continue': 'Davam et →',
  'login.notMember': 'Hələ üzv deyilsiniz?',
  'login.startTrial': 'Pulsuz sınaq başlat',
  'login.adminLogin': '🔒 Admin girişi',
  'login.enterPin': 'PIN kodunuzu daxil edin',
  'login.changeTenant': 'Şirkəti dəyişdir',
  'login.clear': 'Təmizlə',
  'login.delete': 'Sil',
  'login.login': 'Daxil ol',
  'login.loggingIn': 'Daxil olunur...',
  'login.defaultPinOwner': 'Varsayılan PIN: <strong>1234</strong> (Sahibkar)',
  'login.defaultPinCashier': 'Varsayılan PIN: <strong>0000</strong> (Kassir)',
  'login.systemInitializing': 'Sistem başladılır...',
  'login.pinMinLength': 'PIN ən azı 4 rəqəm olmalıdır',
  'login.invalidTenantId': 'Düzgün şirkət ID daxil edin',
  'login.tenantNotFound': 'Bu şirkət kodu tapılmadı. Zəhmət olmasa yoxlayın və ya yeni hesab yaradın.',
  'login.loginFailed': 'Giriş uğursuz oldu',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',

  // Signup translations
  'signup.title': 'Pulsuz sınaq başlat',
  'signup.subtitle': '15 gün pulsuz sınaq, kredit kartı tələb olunmur',
  'signup.backToLogin': 'Girişə qayıt',
  'signup.companyCode': 'Şirkət kodu',
  'signup.companyCodePlaceholder': 'misal: cleanpro',
  'signup.companyCodeHelp': 'Bu kod sistem girişi üçün istifadə olunacaq',
  'signup.companyCodeMinLength': 'Şirkət kodu ən azı 3 simvol olmalıdır',
  'signup.companyName': 'Şirkət adı',
  'signup.companyNamePlaceholder': 'Şirkətinizin adı',
  'signup.companyNameRequired': 'Şirkət adı tələb olunur',
  'signup.fullName': 'Ad Soyad',
  'signup.fullNamePlaceholder': 'Tam adınız',
  'signup.fullNameRequired': 'Ad soyad tələb olunur',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+994 55 123 4567',
  'signup.validPhoneRequired': 'Zəhmət olmasa düzgün telefon nömrəsi daxil edin',
  'signup.email': 'E-poçt',
  'signup.emailPlaceholder': 'misal@şirkət.com',
  'signup.validEmailRequired': 'Zəhmət olmasa düzgün e-poçt ünvanı daxil edin',
  'signup.createAccount': 'Hesab yarat',
  'signup.creating': 'Yaradılır...',
  'signup.terms': 'Hesab yaratmaqla Xidmət Şərtlərimizə və Məxfilik Siyasətimizə razı olursunuz.',
  'signup.success': 'Qeydiyyat uğurlu oldu! Giriş məlumatları e-poçtunuza göndərildi.',
  'signup.successTitle': 'Qeydiyyat uğurlu!',
  'signup.successMessage': 'Hesabınız uğurla yaradıldı.',
  'signup.emailSent': 'Giriş məlumatları e-poçtunuza göndərildi.',
  'signup.redirecting': 'Giriş səhifəsinə yönləndirilir...',
  'signup.startupPackageLoaded': 'Başlanğıc paketi yükləndi!',
  'signup.products': 'Məhsul',
  'signup.customers': 'Müştəri',
  'signup.users': 'İstifadəçi',
  'signup.demoDataReady': '✨ Demo məlumatlarınız hazırdır, dərhal istifadəyə başlaya bilərsiniz!',
  'signup.loginInfo': '📧 Giriş məlumatlarınız',
  'signup.loginInfoSent': '💡 Bu məlumatlar e-poçtunuza da göndərildi',
  'signup.loginNow': 'İndi daxil ol →',
  'signup.bt.tailoring.desc': 'Tikiş, düzəliş və terzixana xidmətləri',
  'signup.bt.barber.desc': 'Bərbər, kuaför və gözəllik salonu',
  
  // Account Statement Page
  'accountStatement.title': 'Hesab çıxarışı',
  'accountStatement.subtitle': 'Müştəri əsaslı hesab alacaq izləməsi',
  'accountStatement.selectCustomer': 'Müştəri seç',
  'accountStatement.customerPlaceholder': 'Müştəri seçin...',
  'accountStatement.searchCustomer': 'Ad, telefon və ya ünvana görə axtar...',
  'accountStatement.noCustomerSelected': 'Zəhmət olmasa müştəri seçin',
  'accountStatement.currentBalance': 'Cari balans',
  'accountStatement.totalDebt': 'Ümumi borc',
  'accountStatement.totalPayments': 'Ümumi ödənişlər',
  'accountStatement.transactions': 'Əməliyyatlar',
  'accountStatement.noTransactions': 'Bu müştəri üçün əməliyyat qeydi tapılmadı',
  'accountStatement.date': 'Tarix',
  'accountStatement.description': 'Təsvir',
  'accountStatement.debit': 'Borc',
  'accountStatement.credit': 'Kredit',
  'accountStatement.balance': 'Balans',
  'accountStatement.order': 'Sifariş',
  'accountStatement.payment': 'Ödəniş',
  'accountStatement.loadError': 'Hesab çıxarışının yüklənməsində xəta',
  'accountStatement.addPayment': 'Ödəniş əlavə et',
  'accountStatement.paymentAmount': 'Ödəniş məbləği',
  'accountStatement.paymentMethod': 'Ödəniş üsulu',
  'accountStatement.paymentNotes': 'Qeydlər (istəyə bağlı)',
  'accountStatement.recordPayment': 'Ödənişi qeyd et',
  'accountStatement.paymentSaved': 'Ödəniş qeyd edildi',
  'accountStatement.paymentError': 'Ödənişin qeyd edilməsində xəta',
  'accountStatement.selectCustomerFirst': 'Zəhmət olmasa əvvəlcə müştəri seçin',
  'accountStatement.exportStatement': 'Çıxarışı ixrac et',
  'accountStatement.exportStatementPDF': 'PDF yüklə',
  'accountStatement.noCustomersFound': 'Müştəri tapılmadı',
  'accountStatement.searchHint': 'Müştəriləri axtarmaq üçün ən azı 2 simvol daxil edin',
  'accountStatement.selectedCustomer': 'Seçilmiş müştəri',
  'accountStatement.changeCustomer': 'Müştərini dəyişdir',
  
  // Toast Messages
  'toast.usernameRequired': 'İstifadəçi adı tələb olunur',
  'toast.firstLoginChangePin': '⚠️ İlk giriş - Zəhmət olmasa PIN kodunuzu dəyişdirin',
  'toast.tenantNotFound': 'Şirkət tapılmadı: "{tenantId}"\\n\\nZəhmət olmasa yeni şirkət hesabı yaratmaq üçün "Pulsuz sınaq başlat" düyməsinə basın.',
  'toast.tenantIdNotRemembered': '🗑️ Şirkət ID yadda saxlanılmayacaq',
  'toast.demoDataLoaded': 'Demo istifadəçilər, məhsullar, müştərilər və sifarişlər yaradıldı!',
  
  'toast.productsLoadError': 'Məhsulların yüklənməsində xəta',
  'toast.statsLoadError': 'Statistikaların yüklənməsində xəta',
  'toast.deliveryBeforeToday': 'Çatdırılma tarixi bu gündən əvvəl ola bilməz',
  'toast.customerOpenOrders': 'Müştərinin {count} açıq sifarişi var',
  'toast.customerDebt': 'Müştərinin {amount} borcu var',
  'toast.customerSaved': 'Müştəri yadda saxlanıldı',
  'toast.customerSaveError': 'Müştərinin yadda saxlanmasında xəta',
  'toast.customerUpdated': 'Müştəri yeniləndi',
  'toast.customerUpdateError': 'Müştərinin yenilənməsində xəta',
  'toast.productAddedToCart': 'Məhsul səbətə əlavə edildi',
  'toast.enterValidArea': 'Zəhmət olmasa düzgün sahə daxil edin',
  'toast.carpetsAddedToCart': '{count} xalça səbətə əlavə edildi ({area} m² x {price}/m²)',
  'toast.carpetAddedToCart': 'Xalça səbətə əlavə edildi ({area} m² x {price}/m²)',
  'toast.selectAtLeastOneService': 'Zəhmət olmasa ən azı bir xidmət seçin',
  'toast.productAdded': 'Məhsul əlavə edildi',
  'toast.productDetailsUpdated': 'Məhsul təfərrüatları yeniləndi',
  'toast.priceUpdated': 'Qiymət yeniləndi',
  'toast.fillAllCardInfo': 'Zəhmət olmasa bütün kart məlumatlarını doldurun',
  'toast.invalidCardNumber': 'Düzgün olmayan kart nömrəsi',
  'toast.invalidMonth': 'Düzgün olmayan ay (1-12 arası olmalıdır)',
  'toast.invalidYear': 'Düzgün olmayan il',
  'toast.invalidCvc': 'Düzgün olmayan CVC',
  'toast.cardPaymentSuccess': 'Kart ödənişi uğurlu oldu!',
  'toast.cardPaymentError': 'Kart ödənişi uğursuz oldu',
  'toast.paymentFailed': 'Ödəniş uğursuz oldu. Zəhmət olmasa yenidən cəhd edin.',
  'toast.paymentStatusCheckError': 'Ödəniş statusunun yoxlanmasında xəta. Zəhmət olmasa hesabınızı yoxlayın.',
  'toast.selectCustomer': 'Zəhmət olmasa müştəri seçin',
  'toast.addProduct': 'Zəhmət olmasa məhsul əlavə edin',
  'toast.addressRequiredForDelivery': 'Evə çatdırılma üçün müştəri ünvanı tələb olunur. Zəhmət olmasa ünvan əlavə edin.',
  'toast.orderSaved': 'Sifariş yadda saxlanıldı',
  'toast.orderSaveError': 'Sifarişin yadda saxlanmasında xəta',
  'toast.enterValidValue': 'Düzgün dəyər daxil edin (0-100)',
  'toast.enterValidAmount': 'Düzgün məbləğ daxil edin',
  'toast.amountExceedsRemaining': 'Məbləğ qalan balansdan çox ola bilməz',
  'toast.selectPaymentMethodFirst': 'Əvvəlcə ödəniş üsulu seçin və məbləğ daxil edin',
  'toast.selectAtLeastOneOperation': 'Zəhmət olmasa ən azı bir əməliyyat seçin',
  'toast.tailorAddedToCart': 'Dərzilik əməliyyatı səbətə əlavə edildi',
  
  'toast.receiptCopied': '📋 Qəbz kopyalandı! WhatsApp Web-də kontaktu seçin və yapışdırın (Ctrl+V)',
  'toast.autoCopyFailed': '⚠️ Avto kopyalama uğursuz oldu. Zəhmət olmasa önizləmədən əl ilə kopyalayın.',
  'toast.printingLabel': 'Etiket çap edilir {current}/{total}...',
  'toast.markedAsReady': '✅ Sifariş hazır olaraq qeyd edildi',
  'toast.messageCopied': '📋 Mesaj kopyalandı! WhatsApp-da yapışdırın (Ctrl+V)',
  'toast.whatsappSending': 'WhatsApp mesajı göndərilir...',
  'toast.readyMarkError': 'Hazır qeyd edilməsində xəta',
  'toast.markedAsDelivered': '✅ Sifariş çatdırıldı olaraq qeyd edildi',
  'toast.deliveredMarkError': 'Çatdırıldı qeyd edilməsində xəta',
  'toast.copyFailed': '⚠️ Kopyalama uğursuz oldu. Mətni seçin və Ctrl+C basın',
  'toast.textSelected': '✅ Mətn seçildi! Ctrl+C ilə kopyalayın',
  'toast.textSelectFailed': 'Mətni seçmək mümkün olmadı',
  'toast.statusUpdated': 'Status yeniləndi',
  'toast.smsSent': 'SMS göndərildi',
  'toast.statusUpdateError': 'Statusun yenilənməsində xəta',
  'toast.cancelReasonRequired': 'Ləğv səbəbi tələb olunur',
  'toast.orderCancelled': 'Sifariş ləğv edildi',
  'toast.cancelError': 'Ləğv edilmə xətası',
  'toast.deliverySuccess': 'Çatdırılma uğurlu oldu',
  'toast.deliveryError': 'Çatdırılma xətası',
  'toast.orderSetToReady': 'Sifariş hazır olaraq qeyd edildi',
  
  'toast.tenantIdNotFound': 'Tenant ID tapılmadı',
  'toast.demoProductsLoaded': 'Demo məhsullar yükləndi!',
  'toast.productsAddError': 'Məhsulların əlavə edilməsində xəta',
  'toast.englishNamesMigration': '{count} məhsula İngilis adları əlavə edildi',
  'toast.migrationFailed': 'Köçürmə uğursuz oldu',
  'toast.multiLanguageConversion': '✅ {count} məhsul çoxdilli formata çevrildi!',
  'toast.multiLanguageConversionError': 'Çoxdilli çevrilmə xətası',
  'toast.productNameRequired': 'Məhsul adı tələb olunur',
  'toast.productUpdated': 'Məhsul yeniləndi',
  'toast.productDeleted': 'Məhsul silindi',
  'toast.productDeleteError': 'Məhsulun silinməsində xəta',
  
  'toast.whatsappNotInStarter': '⚠️ WhatsApp funksiyası Starter planınızda mövcud deyil. Professional və ya Enterprise-a yüksəldə bilərsiniz.',
  'toast.schemaError': '⚠️ Verilənlər bazası sxemi yoxdur!\\n\\nParametrlər → "🗄️ Sxemi yüklə" → Supabase SQL Editor-da işə salın',
  
  // Order Page
  'order.deliveryDate': 'Çatdırılma tarixi',
  'order.notes': 'Qeydlər',
  'order.createOrder': 'Sifariş yarat',
  'order.cancel': 'Ləğv et',
  'order.discountRate': 'Endirim',
  'order.discountPercent': 'Endirim ({percent}%)',
  'order.discountOptional': 'Endirim (istəyə bağlı)',
  'order.enterDiscountRate': 'Endirim dərəcəsi daxil edin (0-100):',
  'order.quickDiscount': 'Sürətli endirim düymələri',
  'order.discountSummary': 'Endirim xülasəsi',
  'order.debt': 'Borc',
  'order.receivable': 'Alacaq',
  'order.balanced': 'Balanslaşdırılmış',
  'order.totalDebt': 'Ümumi borc',
  'order.totalPayments': 'Ümumi ödənişlər',
  'order.homeDeliveryShort': 'Evə çatdırılma',
  'order.homeDeliveryIcon': '🏠 Evə çatdırılma',
  'order.addressIcon': '📍 Ünvan',
  'order.addressRequiredForDelivery': 'Evə çatdırılma üçün ünvan tələb olunur',
  'order.priceAndDiscountEdit': 'Qiymət və endirim redaktəsi',
  'order.discount': 'Endirim',
  'order.subtotal': 'Ara cəm',
  'order.tax': 'ƏDV',
  'order.grandTotal': 'Ümumi cəm',
  'order.payment': 'Ödəniş',
  'order.paymentMethod': 'Ödəniş üsulu',
  'order.cash': 'Nağd',
  'order.card': 'Kredit kartı',
  'order.credit': 'Veresiyə',
  'order.amountPaid': 'Ödənilmiş məbləğ',
  'order.remainingBalance': 'Qalan balans',
  // ---- eksik çeviriler (2026-10-14) ----
  'accountStatement.allTime': 'Bütün dövr',
  'accountStatement.customer': 'Müştəri',
  'accountStatement.customerReceipts': 'Müştəri qəbzləri',
  'accountStatement.noData': 'Hesab çıxarışı tapılmadı',
  'accountStatement.noReceipts': 'Qəbz tapılmadı',
  'accountStatement.payments': 'Ödənişlər',
  'accountStatement.period': 'Dövr',
  'accountStatement.printStatement': 'Çıxarışı çap et',
  'accountStatement.receipts': 'Qəbzlər',
  'accountStatement.remaining': 'Qalıq',
  'accountStatement.statement': 'Çıxarış',
  'accountStatement.totalPaid': 'Cəmi ödənilib',
  'announcement.trialInfo': 'Sınaq müddətinizin bitməsinə {days} gün qalıb',
  'announcement.welcome': 'Cleandy-yə xoş gəlmisiniz!',
  'areaCalculation.calculatedArea': 'Hesablanmış sahə:',
  'areaCalculation.carpetCount': '🔢 Xalça sayı',
  'areaCalculation.carpetCountPlaceholder': 'Neçə ədəd xalça?',
  'areaCalculation.continue': 'Davam et',
  'areaCalculation.directInput': '📏 m² birbaşa daxil et',
  'areaCalculation.exampleNumber': 'Məs: 4',
  'areaCalculation.exampleSqM': 'Məs: 12.5',
  'areaCalculation.height': 'Uzunluq (m)',
  'areaCalculation.or': 'VƏ YA',
  'areaCalculation.perCarpet': 'Hər xalça üçün',
  'areaCalculation.title': 'Sahənin hesablanması',
  'areaCalculation.total': 'Cəmi',
  'areaCalculation.totalSqM': '📏 Cəmi m² ({count} ədəd xalça üçün)',
  'areaCalculation.width': 'En (m)',
  'attributes.addColor': 'Rəng əlavə et',
  'attributes.addDamage': 'Zədə növü əlavə et',
  'attributes.addError': 'Əlavə etmək alınmadı',
  'attributes.addStain': 'Ləkə növü əlavə et',
  'attributes.color': 'Rəng',
  'attributes.deleteError': 'Atribut silinə bilmədi',
  'attributes.deleted': 'Atribut silindi',
  'attributes.loadError': 'Atributları yükləmək alınmadı',
  'attributes.name': 'Atributun adı',
  'attributes.noAttributes': 'Atribut müəyyən edilməyib',
  'attributes.save': 'Yadda saxla',
  'attributes.saveError': 'Atributlar yadda saxlanıla bilmədi',
  'attributes.saved': 'Atributlar yadda saxlanıldı',
  'attributes.updateError': 'Yeniləmək alınmadı',
  'attributes.value': 'Dəyər',
  'back': 'Geri',
  'cancel': 'Ləğv et',
  'changePin': 'PIN-i dəyiş',
  'changingPin': 'Dəyişdirilir...',
  'charts.branchRevenue': 'Filiallar üzrə dövriyyə',
  'charts.cashCard': 'Nağd + Kredit kartı',
  'charts.cashCardAtDel': '💵 Nağd/Kart (Təhvildə):',
  'charts.cashCardAtReg': '💵 Nağd/Kart (Qeydiyyatda):',
  'charts.collectionSummary': 'Ödəniş yığımı xülasəsi',
  'charts.currentCollections': '📋 Cari hesab yığımı:',
  'charts.customer': 'Müştəri',
  'charts.dailyItems': 'Gündəlik əşya sayı qrafiki',
  'charts.dailyRevenue': 'Gündəlik dövriyyə qrafiki',
  'charts.graphicReports': 'Qrafik hesabatlar',
  'charts.itemCount': 'Əşya sayı',
  'charts.loadError': 'Məlumatlar yüklənə bilmədi',
  'charts.noData': 'Bu dövrdə məlumat tapılmadı',
  'charts.orders': 'Sifariş',
  'charts.periodSuffix': 'dövrü',
  'charts.pieces': 'Əşya sayı',
  'charts.receipts': 'Qəbz sayı',
  'charts.regDelivery': '(Qeydiyyat + Təhvil)',
  'charts.revenue': 'Dövriyyə',
  'charts.selectPeriod': 'Başqa dövr seçin',
  'charts.top10Customers': 'Ən çox dövriyyə edən 10 müştəri',
  'charts.total': 'Cəmi',
  'charts.totalItems': 'Cəmi əşya',
  'charts.totalReceipts': 'Cəmi qəbz',
  'charts.totalRevenue': 'Cəmi dövriyyə',
  'common.allYears': 'Bütün illər',
  'common.autoDetected': 'Avtomatik müəyyən edildi',
  'common.cancelled': 'Ləğv edildi',
  'common.clear': 'Təmizlə',
  'common.export': 'İxrac et',
  'common.exportExcel': 'Excel yüklə',
  'common.exportToExcel': 'Excel-ə ixrac et',
  'common.filter': 'Filtrlə',
  'common.items': 'Məhsullar',
  'common.loadError': 'Yüklənə bilmədi',
  'common.none': 'Yoxdur',
  'common.ok': 'Tamam',
  'common.paid': 'Ödənilib',
  'common.print': 'Çap et',
  'common.printDate': 'Çap tarixi',
  'common.searchError': 'Axtarış xətası',
  'common.searchResults': '(Axtarış nəticəsi)',
  'common.unit': 'Vahid',
  'common.year': 'İl',
  'confirmPin': 'PIN-i təsdiqlə',
  'create': 'Yarat',
  'currentPin': 'Cari PIN',
  'customerCard.address': 'ÜNVAN',
  'customerCard.balanceZero': 'Balans artıq sıfırdır.',
  'customerCard.creditLabel': 'alacaq silinəcək',
  'customerCard.debtLabel': 'borc silinəcək',
  'customerCard.heading': 'MÜŞTƏRİ KARTI',
  'customerCard.printButton': 'Müştəri kartını çap et',
  'customerCard.printTitle': 'Müştəri kartı',
  'customerCard.resetBalance': 'Balansı sıfırla',
  'customerCard.resetConfirm': 'Balans sıfırlanacaq ({label}). Təsdiq edirsiniz?',
  'customerCard.resetError': 'Balans sıfırlana bilmədi',
  'customerCard.resetSuccess': 'Balans sıfırlandı',
  'customerCard.resetting': 'Sıfırlanır...',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerStatement.address': 'Ünvan',
  'customerStatement.allTime': 'Bütün dövr',
  'customerStatement.cancelled': 'LƏĞV',
  'customerStatement.closingBalance': 'Bağlanış balansı',
  'customerStatement.credit': 'Alacaq (Yığılmış)',
  'customerStatement.customerName': 'Müştərinin adı',
  'customerStatement.debit': 'Borc',
  'customerStatement.description': 'Təsvir',
  'customerStatement.endDate': 'Bitmə tarixi',
  'customerStatement.items': 'məhsul',
  'customerStatement.lastMonth': 'Keçən ay',
  'customerStatement.noTransactions': 'Seçilmiş tarix aralığında əməliyyat yoxdur.',
  'customerStatement.openingBalance': 'Açılış balansı',
  'customerStatement.payment': 'Ödəniş',
  'customerStatement.phone': 'Telefon',
  'customerStatement.printPDF': 'Çıxarışı çap et (PDF)',
  'customerStatement.receiptDelivered': 'Təhvil verildi',
  'customerStatement.receiptOpen': 'Açıq',
  'customerStatement.selectDateRange': 'Tarix aralığını seçin',
  'customerStatement.startDate': 'Başlama tarixi',
  'customerStatement.statementDate': 'Çıxarış tarixi',
  'customerStatement.thisMonth': 'Bu ay',
  'customerStatement.title': 'CARİ HESAB ÇIXARIŞI',
  'customerStatement.total': 'CƏMİ',
  'customerStatement.type': 'Növ',
  'customers.add': 'Müştəri əlavə et',
  'customers.adres': 'Ünvan',
  'customers.cannotDeleteWithOrders': 'Bu müştəri silinə bilməz! Müştəriyə aid sifarişlər mövcuddur.',
  'customers.import': 'Müştəriləri idxal et',
  'customers.importTitle': 'Müştəriləri idxal et',
  'customers.legacyHidden': 'Köhnə formatlı müştərilər gizlədildi',
  'customers.notFound': 'Müştəri tapılmadı',
  'customers.phoneMissing': 'Müştərinin telefon nömrəsi qeydə alınmayıb',
  'customers.telefon': 'Telefon',
  'customers.telefon2': 'Telefon 2',
  'customers.totalOrders': 'Sifariş sayı',
  'customers.totalSpent': 'Cəmi xərc',
  'damage.add': 'Zədə əlavə et',
  'damage.burn': 'Yanıq',
  'damage.button': 'Düymə problemi',
  'damage.buttonMissing': 'Düymə çatışmır',
  'damage.color': 'Rəng atması',
  'damage.delik': 'Deşik',
  'damage.description': 'Təsvir',
  'damage.fade': 'Solma',
  'damage.fray': 'Köhnəlmə',
  'damage.hole': 'Deşik',
  'damage.lining': 'Astar',
  'damage.location': 'Yer',
  'damage.multiple': 'Zədə vəziyyəti (bir neçəsi seçilə bilər)',
  'damage.noPhoto': 'Foto yoxdur',
  'damage.none': 'Yoxdur',
  'damage.other': 'Digər zədə...',
  'damage.pembe': 'Çəhrayı ləkə',
  'damage.photo': 'Foto',
  'damage.saveError': 'Zədə hesabatı yadda saxlanıla bilmədi',
  'damage.saved': 'Zədə hesabatı yadda saxlanıldı',
  'damage.seam': 'Tikiş',
  'damage.severity': 'Ciddilik dərəcəsi',
  'damage.stain': 'Ləkə',
  'damage.tear': 'Cırıq',
  'damage.title': 'Zədə hesabatı',
  'damage.type': 'Zədə növü',
  'damage.worn': 'Aşınma',
  'damage.zipper': 'Fermuar',
  'dashboard.allTime': 'Bütün dövr',
  'dashboard.referral.button': 'Dəvət et',
  'dashboard.referral.desc': 'Dəvət etdiyin müəssisə üzv olanda 1 ay əlavə!',
  'dashboard.referral.title': 'Dostunu dəvət et',
  'dashboard.totalOrdersCard': 'Cəmi sifariş',
  'delivery.actions': 'Əməliyyatlar',
  'delivery.complete': 'Təhvil ver',
  'delivery.customer': 'Müştəri',
  'delivery.delivered': 'Təhvil verildi',
  'delivery.deliveredItems': 'Təhvil verildi',
  'delivery.deliveredProducts': 'TƏHVİL VERİLƏN MƏHSULLAR',
  'delivery.deliveryDate': 'Təhvil tarixi',
  'delivery.error': 'Çatdırılma xətası',
  'delivery.items': 'Məhsullar',
  'delivery.loadError': 'Çatdırılmaları yükləmək alınmadı',
  'delivery.markDelivered': 'Təhvil verildi kimi qeyd et',
  'delivery.markReady': 'Hazır kimi qeyd et',
  'delivery.noOrders': 'Sifariş tapılmadı',
  'delivery.orderDelivered': 'Sifariş təhvil verildi kimi qeyd edildi',
  'delivery.orderNumber': 'Sifariş №',
  'delivery.orderReady': 'Sifariş hazır kimi qeyd edildi',
  'delivery.pending': 'İcrada',
  'delivery.printReceipt': 'Qəbzi çap et',
  'delivery.ready': 'Hazır',
  'delivery.searchOrder': 'Sifariş nömrəsi və ya müştəri adı ilə axtarın...',
  'delivery.status': 'Status',
  'delivery.success': 'Təhvil uğurlu oldu',
  'delivery.title': 'Çatdırılma idarəetməsi',
  'delivery.total': 'Cəmi',
  'delivery.updateError': 'Statusu yeniləmək alınmadı',
  'deliveryList.address': 'Ünvan',
  'deliveryList.branchUpdated': 'Təhvil filialı yeniləndi',
  'deliveryList.cancelButton': 'Ləğv et',
  'deliveryList.cancelConfirm': 'Bu sifarişi ləğv etmək istədiyinizə əminsiniz? Ləğv səbəbi məcburidir.',
  'deliveryList.cancelError': 'Ləğv xətası',
  'deliveryList.cancelReasonPlaceholder': 'Ləğv səbəbi (məcburi)...',
  'deliveryList.cancelTitle': 'Qəbzin ləğvi',
  'deliveryList.changeBranch': 'Təhvil filialını dəyiş',
  'deliveryList.complete': 'Tamamla',
  'deliveryList.completed': 'Tamamlandı',
  'deliveryList.delivered': 'Təhvil verildi',
  'deliveryList.deliveryError': 'Təhvil verildi kimi qeyd edilərkən xəta',
  'deliveryList.driver': 'Sürücü',
  'deliveryList.homeDelivery': 'Ünvana',
  'deliveryList.items': 'Məhsullar',
  'deliveryList.messageError': 'Müştəriyə mesaj göndərilə bilmədi',
  'deliveryList.noBranch': 'Filial seçilməyib',
  'deliveryList.noBranchAssigned': 'Filial təyin edilməyib',
  'deliveryList.noPhone': 'Müştərinin telefonu tapılmadı',
  'deliveryList.orderCancelled': 'Sifariş ləğv edildi',
  'deliveryList.orderDelivered': 'Sifariş təhvil verildi kimi qeyd edildi',
  'deliveryList.phone': 'Telefon',
  'deliveryList.pickup': 'götürmə',
  'deliveryList.selectBranch': 'Filial seç',
  'deliveryList.selectDriver': 'Sürücü seç',
  'deliveryList.status': 'Status',
  'deliveryList.updateError': 'Yenilənə bilmədi',
  'deliveryList.waRemind': 'WA xatırlat',
  'deliveryList.whatsappError': 'WhatsApp mesajı göndərilə bilmədi',
  'deliveryList.whatsappFailed': 'WhatsApp göndərilə bilmədi',
  'deliveryList.whatsappSent': 'WhatsApp mesajı göndərildi!',
  'deliveryList.whatsappTimeout': 'WhatsApp sorğusunun vaxtı bitdi',
  'deliveryPage.changeDeliveryType': 'Təhvil növünü dəyiş',
  'deliveryPage.changeToDelivery': 'Ünvana çatdırılma',
  'deliveryPage.changeToDeliverySuccess': 'Çatdırılma növü "Ünvana çatdırılma" olaraq dəyişdirildi',
  'deliveryPage.changeToPickup': 'Özü götürəcək',
  'deliveryPage.changeToPickupError': 'Çatdırılma növü dəyişdirilə bilmədi',
  'deliveryPage.changeToPickupSuccess': 'Çatdırılma növü "Özü götürəcək" olaraq dəyişdirildi',
  'deliveryPage.itemsList': 'Sifariş təfərrüatı',
  'deliveryPage.quantity': 'Ədəd',
  'deliveryPage.searchAll': 'Hamısı',
  'deliveryPage.searchBy': 'Axtarış növü:',
  'deliveryPage.searchEmptySubtitle': 'Axtarış etdikdə təhvil veriləcək sifarişlər siyahılanır',
  'deliveryPage.searchEmptyTitle': 'Qəbz №, müştəri adı və ya telefonla axtarın',
  'deliveryPage.searchName': 'Müştərinin adı',
  'deliveryPage.searchNamePlaceholder': 'Qəbz № və ya müştəri adını yazın...',
  'deliveryPage.searchPhone': 'Telefon nömrəsi ilə axtar...',
  'deliveryPage.searchPhoneBtn': 'Telefon',
  'deliveryPage.searchPlaceholder': 'Axtar...',
  'deliveryPage.searchReceipt': 'Qəbz №',
  'deliveryPage.searchReceiptPlaceholder': 'Qəbz № ilə axtar...',
  'deliveryPage.showItems': 'Məhsulları göstər',
  'deliveryPage.unknownProduct': 'Naməlum məhsul',
  'driver.searchHint': 'Axtarış üçün ən azı 2 simvol daxil edin',
  'driver.searchPlaceholder': 'Qəbz №, ad və ya telefon...',
  'error.customerNotCreated': 'Müştəri yaradıla bilmədi',
  'error.customerNotDeleted': 'Müştəri silinə bilmədi',
  'error.customerNotFound': 'Müştəri tapılmadı',
  'error.customerNotUpdated': 'Müştəri yenilənə bilmədi',
  'error.customersNotLoaded': 'Müştərilər yüklənə bilmədi',
  'error.databaseError': 'Verilənlər bazası xətası',
  'error.expenseNotCreated': 'Xərc yaradıla bilmədi',
  'error.expenseNotDeleted': 'Xərc silinə bilmədi',
  'error.expensesNotLoaded': 'Xərclər yüklənə bilmədi',
  'error.forbidden': 'Bu əməliyyat üçün icazəniz yoxdur',
  'error.invalidRequest': 'Yanlış sorğu',
  'error.orderNotCreated': 'Sifariş yaradıla bilmədi',
  'error.orderNotUpdated': 'Sifariş yenilənə bilmədi',
  'error.ordersNotLoaded': 'Sifarişlər yüklənə bilmədi',
  'error.paymentFailed': 'Ödəniş uğursuz oldu',
  'error.phoneAlreadyExists': 'Bu telefon nömrəsi artıq qeydiyyatdadır! Zəhmət olmasa başqa telefon nömrəsindən istifadə edin.',
  'error.productNotCreated': 'Məhsul yaradıla bilmədi',
  'error.productNotUpdated': 'Məhsul yenilənə bilmədi',
  'error.productsNotLoaded': 'Məhsullar yüklənə bilmədi',
  'error.serverError': 'Server xətası',
  'error.tenantIdRequired': 'Sessiya məlumatı tələb olunur',
  'error.tenantIdRequiredLogin': 'Sessiya məlumatı tələb olunur. Zəhmət olmasa daxil olun.',
  'error.unauthorized': 'İcazəsiz giriş',
  'error.unknownError': 'Naməlum xəta baş verdi',
  'error.userNotCreated': 'İstifadəçi yaradıla bilmədi',
  'error.userNotUpdated': 'İstifadəçi yenilənə bilmədi',
  'error.usersNotLoaded': 'İstifadəçilər yüklənə bilmədi',
  'errorBoundary.forbidden': 'Giriş rədd edildi',
  'errorBoundary.forbiddenDetails': 'Bu əməliyyatı yerinə yetirmək üçün icazəniz kifayət deyil.',
  'errorBoundary.goHome': 'Ana səhifəyə qayıt',
  'errorBoundary.pageNotFound': 'Səhifə tapılmadı',
  'errorBoundary.pageNotFoundDetails': 'Axtardığınız səhifə mövcud deyil və ya köçürülmüş ola bilər.',
  'errorBoundary.persistentIssue': 'Problem davam edərsə, zəhmət olmasa dəstək komandası ilə əlaqə saxlayın.',
  'errorBoundary.reload': 'Səhifəni yenilə',
  'errorBoundary.serverError': 'Server xətası',
  'errorBoundary.serverErrorDetails': 'Server tərəfində xəta baş verdi. Zəhmət olmasa sonra yenidən cəhd edin.',
  'errorBoundary.technicalDetails': 'Texniki təfərrüatlar',
  'errorBoundary.unauthorized': 'İcazəsiz giriş',
  'errorBoundary.unauthorizedDetails': 'Bu səhifəyə giriş icazəniz yoxdur.',
  'errorBoundary.unknownError': 'Xəta baş verdi',
  'expenses.allBranches': 'Bütün filiallar',
  'expenses.allTypes': 'Bütün növlər',
  'expenses.branchSelect': 'Filial seç',
  'expenses.canOnlyDeleteToday': 'Yalnız bu gün daxil etdiyiniz xərcləri silə bilərsiniz.',
  'expenses.categoryBy': 'Kateqoriyaya görə',
  'expenses.excelError': 'Excel yaradıla bilmədi',
  'expenses.expenseType': 'Xərc növü',
  'expenses.exportExcel': 'Excel',
  'expenses.myBranch': 'Filialınız',
  'expenses.noBranch': 'Filialsız',
  'expenses.noBranchSelected': '— Filial seçilməyib —',
  'expenses.records': 'qeyd',
  'footer.euServers': 'Məlumatlarınız Avropa İttifaqı (Frankfurt) serverlərimizdə təhlükəsiz saxlanılır.',
  'footer.gdpr': 'GDPR-a uyğun infrastruktur.',
  'form.area': 'Sahə',
  'form.color': 'Rəng',
  'form.damage': 'Zədə',
  'form.notes': 'Qeydlər',
  'form.stain': 'Ləkə',
  'hardware.addToCart': 'Səbətə əlavə et',
  'hardware.addedToCart': 'Səbətə əlavə edildi!',
  'hardware.available': 'Satışda',
  'hardware.barcodeCompatText': 'Bütün 2D barkod oxuyucular CleandySoft ilə işləyə bilər. USB HID rejimində işləyənlər avtomatik dəstəklənir.',
  'hardware.barcodeScannerSubtitle': 'USB barkod və QR kod oxuyucular',
  'hardware.barcodeScanners': 'Barkod oxuyucular',
  'hardware.callerIdCompatText': 'Yalnız CIDShow 2 xəttli model üçün sınaqdan keçirilib. Fərqli marka və ya modellər işləyə bilər, lakin zəmanət verilmir.',
  'hardware.callerIdSubtitle': 'Müştəri zənglərində nömrənin tanınması',
  'hardware.callerIdTitle': 'Zəng edənin identifikasiyası (Caller ID)',
  'hardware.cart': 'Səbət',
  'hardware.cartEmpty': 'Səbət boşdur',
  'hardware.checkout': 'Ödənişə keç',
  'hardware.compatibilityNote': 'Uyğunluq qeydi',
  'hardware.compatibilityTitle': 'CleandySoft uyğunluğu',
  'hardware.driverDownloads': 'Drayver və proqram təminatının yüklənməsi',
  'hardware.driverDownloadsText': 'Printerinizi qoşmazdan əvvəl uyğun drayveri yükləməyiniz tövsiyə olunur.',
  'hardware.features': 'Xüsusiyyətlər',
  'hardware.info': 'Məlumat',
  'hardware.infoOnly': 'Məlumat məqsədli',
  'hardware.infoText': 'Bu avadanlıqlar hazırda yalnız Türkiyədə satın alına bilər. Digər ölkələr üçün məlumat məqsədilə siyahıya alınıb.',
  'hardware.infoTitle': 'Məlumatlandırma',
  'hardware.labelCompatText': 'Epson TM-U220 və Bixolon SRP-270 modelləri üçün sınaqdan keçirilib. Fərqli marka və ya modellərdə problemlər yarana bilər.',
  'hardware.labelPrinters': 'Etiket printerləri',
  'hardware.labelPrintersSubtitle': 'Nöqtəli (matris) printerlər, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.myCart': 'Səbətim',
  'hardware.onlyTurkey': 'Bu məhsul yalnız Türkiyədə satın alına bilər',
  'hardware.receiptCompatText': 'Bütün 80mm termal və kəsicisi olan printerlərlə işləyir.',
  'hardware.receiptPrinters': 'Qəbz printerləri',
  'hardware.receiptPrintersSubtitle': '80mm termal printerlər, avtomatik kəsici',
  'hardware.subtitle': 'Qəbz printerləri, etiket printerləri və Caller ID cihazları',
  'hardware.testedModels': 'Sınaqdan keçirilmiş modellər',
  'hardware.title': 'Avadanlıq mağazası',
  'hardware.total': 'Cəmi',
  'hardware.vatSuffix': '+ ƏDV',
  'invoices.downloading': 'Yüklənir...',
  'loading': 'Yüklənir...',
  'login': 'Giriş',
  'login.credentialsTitle': 'Giriş məlumatları',
  'login.demoAccount': 'Demo hesab',
  'login.demoCredentials': 'İstifadəçi adı: demo, PIN: 1234',
  'login.demoLoaded': 'Demo istifadəçilər, məhsullar, müştərilər və sifarişlər yaradıldı!',
  'login.enterCredentials': 'İstifadəçi adı və PIN daxil edin',
  'login.firstLoginChangePin': 'İlk giriş - Zəhmət olmasa PIN kodunuzu dəyişin',
  'login.forget': 'Unut',
  'login.invalidCredentials': 'Yanlış istifadəçi adı və ya PIN',
  'login.legalText': 'Hesab yaratmaqla Xidmət Şərtlərimizi və Məxfilik Siyasətimizi qəbul etmiş olursunuz',
  'login.pin': 'PIN',
  'login.pinDescription': '4-6 rəqəm',
  'login.pinRequired': 'PIN tələb olunur',
  'login.rememberMe': 'Məni xatırla',
  'login.saveCredentialsNote': 'Bu məlumatları yadda saxlayın!',
  'login.signIn': 'Daxil ol',
  'login.signingIn': 'Daxil olunur...',
  'login.tenantIdNotRemembered': 'Şirkət ID-si yadda saxlanılmayıb',
  'login.tenantRequired': 'Şirkət ID-si tələb olunur',
  'login.tryForFree': '15 gün pulsuz sınayın, kredit kartı tələb olunmur',
  'login.username': 'İstifadəçi adı',
  'login.usernamePlaceholder': 'patron, kassir...',
  'login.usernameRequired': 'İstifadəçi adı tələb olunur',
  'login.version': 'Versiya',
  'logout': 'Çıxış',
  'menu.barber': 'Bərbər / Kuaför',
  'menu.carWash': 'Avtomobil yuma',
  'menu.driverPickup': 'Götürüləcək sifarişlər',
  'menu.hardware': 'Avadanlıq',
  'menu.payment': 'Ödəniş',
  'menu.referral': 'Dəvət et',
  'menu.reportsCharts': 'Qrafik hesabatlar',
  'nav.logout': 'Çıxış et',
  'nav.user': 'İstifadəçi',
  'newPin': 'Yeni PIN',
  'notifications': 'Bildirişlər',
  'notifications.customMessage': 'Fərdi mesaj',
  'notifications.failure': 'Bildiriş göndərilə bilmədi',
  'notifications.message': 'Mesaj',
  'notifications.preview': 'Önizləmə',
  'notifications.schedule': 'Planla',
  'notifications.scheduleLater': 'Sonra göndər',
  'notifications.selectCustomer': 'Müştəri seç',
  'notifications.selectDateTime': 'Tarix və vaxt seç',
  'notifications.selectTemplate': 'Şablon seç',
  'notifications.send': 'Göndər',
  'notifications.sendError': 'Göndərmək alınmadı',
  'notifications.sendNow': 'İndi göndər',
  'notifications.sending': 'Göndərilir...',
  'notifications.sent': 'Göndərildi',
  'notifications.sms': 'SMS',
  'notifications.subtitle': 'SMS və WhatsApp bildiriş ayarlarını tənzimləyin',
  'notifications.success': 'Bildiriş uğurla göndərildi',
  'notifications.title': 'Məlumatlandırma SMS/WhatsApp',
  'notifications.whatsapp': 'WhatsApp',
  'order.addProduct': 'Məhsul əlavə et',
  'order.amount': 'Məbləğ',
  'order.customer': 'Müştəri',
  'order.homeDelivery': 'Ünvana çatdırılma',
  'order.newCustomer': 'Yeni müştəri',
  'order.newPrice': 'Yeni qiymət',
  'order.notesOptional': 'Qeydlər (İstəyə bağlı)',
  'order.notesPlaceholder': 'Əlavə məlumat, xüsusi istəklər...',
  'order.price': 'Qiymət',
  'order.processing': 'Emal olunur...',
  'order.products': 'Məhsullar',
  'order.quantity': 'Ədəd',
  'order.selectCustomer': 'Müştəri seç',
  'order.selectPaymentMethod': 'Ödəniş üsulunu seçin',
  'order.selectProduct': 'Məhsul seç',
  'order.title': 'Yeni sifariş',
  'order.total': 'Cəmi',
  'order.totalWithQuantity': 'Cəmi ({count} ədəd)',
  'orderCreate.continue': 'Davam et',
  'orderCreate.pickupFromAddress': 'Sürücü ünvandan götürəcək',
  'orderCreate.selectOperation': 'Əməliyyat seçin (qiymətlər avtomatik əlavə olunacaq)',
  'orderCreate.selectedOperations': 'Seçilmiş əməliyyatlar',
  'payment.adjustment': 'Balans düzəlişi',
  'payment.bank': 'Bank köçürməsi',
  'payment.card': 'Kredit kartı',
  'payment.collect': 'Ödənişi qəbul et',
  'payment.credit': 'Nisyə',
  'payment.enterAmount': 'Ödəniş məbləğini daxil edin',
  'payment.free': 'Ödənişsiz',
  'payment.madePayments': 'Edilmiş ödənişlər',
  'payment.paymentCare': 'Cari hesab ödənişi',
  'payment.paymentsSaved': 'Ödənişlər yadda saxlanıldı',
  'payment.saveError': 'Ödənişlər yadda saxlanıla bilmədi',
  'payment.saved': 'Ödəniş yadda saxlanıldı',
  'payment.split': 'Hissəli ödəniş',
  'pinDigits': '6 rəqəmli',
  'placeholder.customerAddress': 'Məs: NƏSİMİ, BAKI',
  'placeholder.customerEmail': 'Məs: ahmet@example.com',
  'placeholder.customerName': 'Məs: ƏLİ MƏMMƏDOV',
  'placeholder.customerNotes': 'Məs: VIP MÜŞTƏRİ',
  'placeholder.customerPhone': 'Məs: 050 123 45 67',
  'pricing.amount': 'Məbləğ',
  'pricing.enterPrice': 'Qiyməti daxil edin',
  'pricing.percent': 'Faiz',
  'product.damage': 'Zədə',
  'product.stain': 'Ləkə',
  'products.addError': 'Məhsulu əlavə etmək alınmadı',
  'products.allCategories': 'Bütün kateqoriyalar',
  'products.delete': 'Sil',
  'products.deleteConfirm': 'Bu məhsulu silmək istədiyinizə əminsiniz?',
  'products.deleteError': 'Məhsulu silmək alınmadı',
  'products.deleting': 'Silinir...',
  'products.editProduct': 'Məhsulu redaktə et',
  'products.loadError': 'Məhsulları yükləmək alınmadı',
  'products.newProduct': 'Yeni məhsul',
  'products.pieceCount': 'Əşya sayı',
  'products.productActive': 'Aktiv',
  'products.productAdded': 'Məhsul əlavə edildi',
  'products.productCategory': 'Kateqoriya',
  'products.productDeleted': 'Məhsul silindi',
  'products.productInActive': 'Deaktiv',
  'products.productName': 'Məhsulun adı',
  'products.productPrice': 'Qiymət',
  'products.productUpdated': 'Məhsul yeniləndi',
  'products.save': 'Yadda saxla',
  'products.saveError': 'Yadda saxlamaq alınmadı',
  'products.saved': 'Yadda saxlanıldı',
  'products.saving': 'Yadda saxlanılır...',
  'products.searchProduct': 'Məhsul axtar...',
  'products.updateError': 'Məhsulu yeniləmək alınmadı',
  'products.updatePrice': 'Qiyməti yenilə',
  'products.updatePrices': 'Qiymətləri yenilə',
  'profile.changePassword': 'Şifrəni dəyiş',
  'profile.confirmPassword': 'Şifrəni təsdiqlə',
  'profile.currentPassword': 'Cari şifrə',
  'profile.email': 'E-poçt',
  'profile.name': 'Ad',
  'profile.newPassword': 'Yeni şifrə',
  'profile.passwordChangeError': 'Şifrəni dəyişmək alınmadı',
  'profile.passwordChanged': 'Şifrə uğurla dəyişdirildi',
  'profile.passwordMismatch': 'Şifrələr uyğun gəlmir',
  'profile.phone': 'Telefon',
  'profile.role': 'Rol',
  'profile.save': 'Yadda saxla',
  'profile.saveError': 'Profili yadda saxlamaq alınmadı',
  'profile.saved': 'Yadda saxlanıldı',
  'profile.saving': 'Yadda saxlanılır...',
  'profile.subscriptionBilling': 'Abunəlik və hesab-faktura',
  'profile.title': 'Profil',
  'receipt.allYears': 'Bütün illər',
  'receipt.backButton': 'Geri qayıt',
  'receipt.buyCredits': 'Kredit almaq üçün Ayarlar → WhatsApp bağlantısı bölməsinə keçin.',
  'receipt.cancelled': 'LƏĞV EDİLİB',
  'receipt.cancelledBanner': 'LƏĞV EDİLİB',
  'receipt.cancelledBy': 'Ləğv edən',
  'receipt.cancelledDate': 'Ləğv tarixi',
  'receipt.cancelledReason': 'Ləğv səbəbi',
  'receipt.card': 'Kart',
  'receipt.cash': 'Nağd',
  'receipt.change': 'Qaytarılan pul',
  'receipt.connect': 'Qoşul',
  'receipt.connected': 'Qoşulub',
  'receipt.copyButton': 'Kopyala',
  'receipt.copySend': 'WhatsApp mesajı göndər',
  'receipt.copyTip': 'İpucu: Mətni seçib Ctrl+C ilə də kopyalaya bilərsiniz',
  'receipt.creditsFinished': 'WhatsApp kreditləriniz bitib!',
  'receipt.customer': 'Müştəri',
  'receipt.customerInfo': 'Müştəri',
  'receipt.customerName': 'Müştərinin adı',
  'receipt.deliveryDate': 'Təhvil tarixi',
  'receipt.freeOfCharge': 'Ödənişsiz',
  'receipt.goToWhatsAppPage': 'WhatsApp bağlantı səhifəsinə keçmək istəyirsiniz?',
  'receipt.grandTotal': 'Ümumi cəm',
  'receipt.invalid': 'ETİBARSIZ',
  'receipt.items': 'Məhsullar',
  'receipt.label': 'Etiket',
  'receipt.labelConfirmDesc': 'Qəbz kəsildi. Etiket printerinə etiket göndərilsin?',
  'receipt.labelConfirmTitle': 'Etiket çap edilsin?',
  'receipt.labelNo': 'Xeyr',
  'receipt.labelPrinted': 'Etiket çap edildi!',
  'receipt.labelYes': 'Bəli, çap et',
  'receipt.markAsDelivered': 'Sifarişi təhvil ver',
  'receipt.markAsReady': 'Sifarişi hazır kimi qeyd et',
  'receipt.markDeliveredError': 'Təhvil verildi kimi qeyd edilərkən xəta',
  'receipt.markReadyError': 'Hazır kimi qeyd edilərkən xəta',
  'receipt.messageFailed': 'Mesaj göndərilə bilmədi',
  'receipt.messageSendFailed': 'Mesaj göndərilə bilmədi',
  'receipt.messageSent': 'Mesaj göndərildi!',
  'receipt.new': 'Yeni qəbz',
  'receipt.noCollection': 'Yığım yoxdur',
  'receipt.noReceiptFound': 'Qəbz tapılmadı',
  'receipt.notes': 'Qeydlər',
  'receipt.onlyProEnterprise': 'Yalnız Pro/Enterprise',
  'receipt.openWhatsApp': 'WhatsApp-da aç',
  'receipt.orderMarkedDelivered': 'Sifariş təhvil verildi kimi qeyd edildi',
  'receipt.orderMarkedReady': 'Sifariş hazır kimi qeyd edildi',
  'receipt.orderNumber': 'Sifariş №',
  'receipt.orderReceived': 'Sifariş qəbul edildi',
  'receipt.paid': 'Ödənilib',
  'receipt.partialPayment': 'Qismən ödəniş',
  'receipt.paymentMethod': 'Ödəniş üsulu',
  'receipt.phone': 'Telefon',
  'receipt.phoneNotFound': 'Telefon nömrəsi tapılmadı',
  'receipt.preview': 'Qəbzə önizləmə',
  'receipt.printError': 'Çap xətası',
  'receipt.printerConnectError': 'Printerə qoşulmaq alınmadı',
  'receipt.productsInfo': 'Məhsullar',
  'receipt.receiptInfo': 'Qəbz məlumatı',
  'receipt.remaining': 'Qalıq',
  'receipt.remainingCredits': 'Qalan kreditlər',
  'receipt.reprint': 'Yenidən çap et',
  'receipt.scanQR': 'QR kodu skan etmək üçün Ayarlar → WhatsApp bağlantısı bölməsinə keçin.',
  'receipt.searchAll': 'Hamısı',
  'receipt.searchBy': 'Axtarış meyarı',
  'receipt.searchError': 'Axtarış xətası',
  'receipt.searchName': 'Müştərinin adı',
  'receipt.searchPhone': 'Telefon',
  'receipt.searchReceipt': 'Qəbz axtar',
  'receipt.searchReceiptPlaceholder': 'Qəbz nömrəsini daxil edin...',
  'receipt.searchTitle': 'Qəbz axtar',
  'receipt.selectAll': 'Hamısını seç',
  'receipt.serviceSummary': 'XİDMƏT XÜLASƏSİ',
  'receipt.sessionNotFound': 'Sessiya tapılmadı. Zəhmət olmasa yenidən daxil olun.',
  'receipt.status': 'Status',
  'receipt.thermalPrinter': 'Termal printer',
  'receipt.thisReceiptCancelled': 'BU QƏBZ LƏĞV EDİLİB',
  'receipt.unknownError': 'Naməlum xəta',
  'receipt.whatsappFeature': 'WhatsApp funksiyası Professional və Enterprise planlarında mövcuddur',
  'receipt.whatsappNotConnected': 'WhatsApp qoşulmayıb!',
  'receipt.whatsappPreview': 'WhatsApp mesajına önizləmə',
  'receipt.whatsappPreviewDesc': 'Bu mesaj WhatsApp-da göndəriləcək',
  'receipt.whatsappPreviewTitle': 'WhatsApp mesajının önizləməsi',
  'receipt.year': 'İl',
  'reports.averageOrder': 'Orta sifariş',
  'reports.dateRange': 'Tarix aralığı',
  'reports.ordersCount': 'Sifariş sayı',
  'reports.salesReport': 'Satış hesabatı',
  'reports.totalSales': 'Cəmi satış',
  'reportsList.activeOnly': 'Yalnız aktiv sifarişlər',
  'reportsList.activeReceipt': 'Aktiv qəbz',
  'reportsList.amount': 'Məbləğ',
  'reportsList.cancelReason': 'Ləğv səbəbi:',
  'reportsList.cancelled': 'Ləğv edildi',
  'reportsList.categoryBreakdown': 'Kateqoriyaya görə bölgü',
  'reportsList.changeDateRange': 'Başqa tarix aralığı seçin',
  'reportsList.created': 'Yaradılma',
  'reportsList.customer': 'Müştəri',
  'reportsList.date': 'Tarix',
  'reportsList.dateError': 'Başlama tarixi bitmə tarixindən sonra ola bilməz',
  'reportsList.delivered': 'Təhvil',
  'reportsList.deliveredThisPeriod': '📦 Əvvəl qeydə alınıb, bu dövrdə təhvil verilib ({count} qəbz)',
  'reportsList.description': 'Bu tarix aralığında qeydə alınan və ya təhvil verilən bütün qəbzlər siyahılanır',
  'reportsList.empty': 'Bu tarix aralığında qəbz tapılmadı',
  'reportsList.endDate': 'Bitmə tarixi',
  'reportsList.excelDownloaded': 'Excel faylı yükləndi',
  'reportsList.excelError': 'Excel faylı yaradıla bilmədi',
  'reportsList.loadError': 'Qəbz siyahısı yüklənə bilmədi',
  'reportsList.loading': 'Yüklənir...',
  'reportsList.noOrders': 'Sifariş tapılmadı',
  'reportsList.payment': 'Ödəniş',
  'reportsList.phone': 'Telefon',
  'reportsList.receiptNumber': 'Qəbz №',
  'reportsList.registered': 'Qeydə alınan',
  'reportsList.registeredThisPeriod': '📝 Bu dövrdə qeydə alınan ({count} qəbz)',
  'reportsList.reprint': 'Yenidən çap et',
  'reportsList.search': 'Axtar',
  'reportsList.searchPlaceholder': 'Qəbz №, müştəri adı və ya telefon...',
  'reportsList.startDate': 'Başlama tarixi',
  'reportsList.status': 'Status',
  'reportsList.title': 'Qəbz siyahısı hesabatı',
  'reportsList.totalReceipt': 'Cəmi qəbz',
  'reportsList.totalReceipts': 'Cəmi qəbzlər',
  'reportsList.totalRevenueExclCancelled': 'Cəmi dövriyyə (ləğvlər istisna olmaqla)',
  'reportsList.unknown': 'Naməlum',
  'save': 'Yadda saxla',
  'service.barber': 'Bərbər / Kuaför',
  'service.carWash': 'Avtomobil yuma',
  'service.carpetShort': 'XLÇ',
  'service.dryCleaningFull': 'Quru təmizləmə',
  'service.dryCleaningShort': 'QT',
  'service.ironingShort': 'ÜT',
  'service.dyeingShort': 'BY',
  'service.shoeShineShort': 'AYQ',
  'service.sofaWashing': 'Divan yuma',
  'service.tailoringShort': 'DRZ',
  'service.washingShort': 'YM',
  'settings.addDemoProducts': 'Demo məhsulları əlavə et',
  'settings.adding': 'Əlavə edilir...',
  'settings.addressPlaceholder': 'Şirkət ünvanını daxil edin',
  'settings.africa': 'Afrika',
  'settings.afrika': 'Afrika',
  'settings.americas': 'Amerika',
  'settings.asia': 'Asiya',
  'settings.asiaPacific': 'Asiya-Sakit okean',
  'settings.asianLanguages': 'Asiya dilləri',
  'settings.autoConnect': 'Avtomatik qoşul',
  'settings.browserNotSupported': 'Brauzer dəstəkləmir',
  'settings.callerId': 'Zəng edənin identifikasiyası (Caller ID)',
  'settings.clickConnectButton': '"Qoşul" düyməsinə klikləyin',
  'settings.company': 'Şirkət',
  'settings.companyInfo': 'Şirkət məlumatları',
  'settings.companyNamePlaceholder': 'Şirkət adını daxil edin',
  'settings.connect': 'Qoşul',
  'settings.connectDeviceInfo': 'USB Caller ID cihazını kompüterə qoşun',
  'settings.connected': 'Qoşulub',
  'settings.currencyPositionPreview': 'Simvol {position}: {example}',
  'settings.cut': 'Kəs',
  'settings.delete': 'Sil',
  'settings.deleteButton': 'Demo məlumatlarını sil',
  'settings.deleteDemoDataDesc': 'Bu əməliyyat bütün demo müştəriləri, sifarişləri və ödəniş qeydlərini həmişəlik siləcək.',
  'settings.demoProducts': 'Demo məhsulları',
  'settings.demoProductsDescription': 'Müəyyən edilmiş qiymətləri ilə birlikdə demo məhsulları əlavə edir',
  'settings.disconnect': 'Bağlantını kəs',
  'settings.email': 'E-poçt',
  'settings.europe': 'Avropa',
  'settings.europeanLanguages': 'Avropa dilləri',
  'settings.expenses': 'Xərclər',
  'settings.feedForward': 'Kağızı irəli ötür',
  'settings.footerPlaceholder': 'Alt məlumat mesajı',
  'settings.footerText': 'Alt məlumat mətni',
  'settings.footerTextHelp': 'Qəbzin altında görünəcək qısa mesaj',
  'settings.footerTextPlaceholder': 'Qəbzin altında görünəcək mətn...',
  'settings.formerSovietTurkic': 'Keçmiş Sovet və Türk',
  'settings.genericEscPos': 'Ümumi ESC/POS',
  'settings.headerInfo': 'Üst məlumat',
  'settings.headerInfoPlaceholder': 'məs: Quru təmizləmə və Ütü',
  'settings.howToConnect': '💡 Necə qoşulmalı?',
  'settings.integrations': 'İnteqrasiyalar',
  'settings.invoices': 'Hesab-fakturalar',
  'settings.labelPrinter': 'Etiket printeri',
  'settings.languageRegion': 'Dil və region',
  'settings.lastCall': 'Son zəng',
  'settings.loadSchema': 'Sxemi yüklə',
  'settings.loadSchemaConfirm': 'Bu, verilənlər bazası sxemini yaradacaq. Davam edilsin?',
  'settings.loadSchemaTitle': 'Verilənlər bazası sxemini yüklə',
  'settings.logo': 'Loqo',
  'settings.majorCurrencies': 'Əsas valyutalar',
  'settings.menu': 'Ayarlar menyusu',
  'settings.middleEast': 'Yaxın Şərq',
  'settings.middleEastAfricanLanguages': 'Yaxın Şərq və Afrika dilləri',
  'settings.middleEastGulf': 'Yaxın Şərq və Körfəz',
  'settings.notConnected': 'Qoşulmayıb',
  'settings.notifications': 'Bildirişlər',
  'settings.numberFormatCommaDot': '1.234,56 (TR/AB)',
  'settings.numberFormatDotComma': '1,234.56 (ABŞ)',
  'settings.numberFormatSpaceComma': '1 234,56 (FR/RU)',
  'settings.oceania': 'Okeaniya',
  'settings.openDrawer': 'Siyirməni aç',
  'settings.orderCreated': 'Sifariş yaradıldı',
  'settings.orderDelivered': 'Sifariş təhvil verildi',
  'settings.orderReady': 'Sifariş hazırdır',
  'settings.otherLanguages': 'Digər dillər',
  'settings.paperWidth': 'Kağız eni',
  'settings.phonePlaceholder': 'məs: 012 123 45 67',
  'settings.popularLanguages': 'Populyar dillər',
  'settings.previewItem1': 'Məhsul 1',
  'settings.previewItem2': 'Məhsul 2',
  'settings.previewTotal': 'CƏMİ',
  'settings.printer': 'Printer',
  'settings.printerConnect': 'Qoşul',
  'settings.printerConnected': 'Qoşulub',
  'settings.printerConnection': 'Printer bağlantısı',
  'settings.printerDisconnect': 'Bağlantını kəs',
  'settings.printerModel': 'Printer modeli',
  'settings.printerNotConnected': 'Qoşulmayıb',
  'settings.printerSettings': 'Printer ayarları',
  'settings.receiptNoteHelp': 'Ətraflı şərtlər və qaydalar',
  'settings.receiptNotePlaceholder': 'Qəbz qeydi...',
  'settings.receiptPreview': 'Qəbzə önizləmə',
  'settings.receiptVisibleOnReceipt': 'Qəbzdə görünür',
  'settings.reports': 'Hesabatlar',
  'settings.reverse': 'Geri çək',
  'settings.reverseTest': '--- Tərs ödəniş testi ---',
  'settings.saveError': 'Ayarlar yadda saxlanıla bilmədi',
  'settings.saved': 'Ayarlar yadda saxlanıldı!',
  'settings.selectDevice': 'Açılan siyahıdan CID cihazını seçin (adətən "USB Serial Device")',
  'settings.showTax': 'ƏDV-ni göstər',
  'settings.smsTemplates': 'SMS mesaj şablonları',
  'settings.successful': 'uğurlu!',
  'settings.testPrint': 'Test çapı',
  'settings.testPrintHeader': '=== TEST PRİNTER ===',
  'settings.testPrinted': 'Test çap edildi!',
  'settings.tickets': 'Dəstək müraciətləri',
  'settings.timezone': 'Saat qurşağı',
  'settings.turkey': 'Türkiyə',
  'settings.webSerialNotSupported': 'Web Serial API brauzeriniz tərəfindən dəstəklənmir. Chrome əsaslı brauzerlərdən (Chrome, Edge, Brave) istifadə etməyinizi tövsiyə edirik.',
  'settings.webSerialSupported': 'Web Serial API dəstəklənir',
  'settings.whatsappTemplates': 'WhatsApp mesaj şablonları',
  'settings.zReport': 'Z hesabatı',
  'signup.bt.carWash.desc': 'Avtomobil yuma, cilalama, pasta və detailing',
  'signup.bt.carpetWashing.desc': 'Xalça, palaz, yolluq yuma',
  'signup.bt.dryCleaning.desc': 'Geyim, pərdə, tekstil təmizliyi',
  'signup.bt.shoeShine.desc': 'Ayaqqabı təmizliyi və baxımı',
  'signup.bt.sofaWashing.desc': 'Divan, kreslo, berjer yuma',
  'signup.businessType.continue': 'Davam et',
  'signup.businessType.hint': 'Seçiminizə görə defolt ekran avtomatik tənzimlənir',
  'signup.businessType.question': 'Hansı işlə məşğulsunuz?',
  'signup.companyDetails': 'Şirkət məlumatları',
  'signup.errors.companyCodeRequired': 'Şirkət kodu tələb olunur',
  'signup.errors.companyCodeTooShort': 'Şirkət kodu ən azı 3 simvol olmalıdır',
  'signup.errors.companyNameRequired': 'Şirkət adı tələb olunur',
  'signup.errors.emailInvalid': 'Etibarlı e-poçt ünvanı daxil edin',
  'signup.errors.emailRequired': 'E-poçt ünvanı tələb olunur',
  'signup.errors.ownerNameRequired': 'Ad Soyad tələb olunur',
  'signup.errors.signupFailed': 'Hesab yaratmaq alınmadı',
  'signup.fields.companyCode': 'Şirkət kodu',
  'signup.fields.companyName': 'Şirkət adı',
  'signup.fields.country': 'Ölkə',
  'signup.fields.email': 'E-poçt ünvanı',
  'signup.fields.ownerName': 'Ad Soyad',
  'signup.fields.phone': 'Telefon nömrəsi',
  'signup.freeTrial': '🎁 15 gün pulsuz istifadə hədiyyə!',
  'signup.haveAccount': 'Artıq hesabınız var? Daxil olun',
  'signup.hints.companyCode': 'Bu kod giriş zamanı istifadə olunacaq. Yalnız hərf və rəqəmlərdən ibarət ola bilər.',
  'signup.hints.country': 'Ölkənizə görə valyuta və dil ayarları avtomatik təyin ediləcək.',
  'signup.placeholders.companyCode': 'məs: cleanpro',
  'signup.placeholders.companyName': 'məs: CleanPro Quru Təmizləmə',
  'signup.placeholders.email': 'məs: ali@cleanpro.com',
  'signup.placeholders.ownerName': 'məs: Əli Məmmədov',
  'signup.placeholders.phone': 'məs: +994 50 123 45 67',
  'signup.referral.bonus': 'Referal bonusu',
  'signup.referral.title': 'Dəvət kodu',
  'smsSettingsRequired': 'Test SMS göndərməzdən əvvəl yuxarıdakı SMS ayarlarını konfiqurasiya edib yadda saxlayın',
  'stain.blood': 'Qan',
  'stain.fruit': 'Meyvə',
  'stain.ink': 'Mürəkkəb',
  'stain.mud': 'Palçıq',
  'stain.multiple': 'Ləkə vəziyyəti (bir neçəsi seçilə bilər)',
  'stain.none': 'Yoxdur',
  'stain.oil': 'Yağ',
  'stain.other': 'Digər ləkə...',
  'stain.paint': 'Boya',
  'stain.pembe': 'Çəhrayı',
  'stain.rust': 'Pas',
  'stain.salt': 'Duz',
  'stain.status': 'Ləkə vəziyyəti',
  'stain.teaCoffee': 'Çay/Qəhvə',
  'status.cancelled': 'Ləğv edildi',
  'status.delivered': 'Təhvil verildi',
  'status.pending': 'İcrada',
  'status.pickup_in_progress': 'Götürülür',
  'status.pickup_pending': 'Götürüləcək',
  'status.ready': 'Hazır',
  'status.received': 'Qəbul edildi',
  'subscription.accountManagement': 'Cari hesabların idarə edilməsi',
  'subscription.active': 'Aktiv',
  'subscription.address': 'Ünvan',
  'subscription.addressPlaceholder': 'Hesab-faktura ünvanını daxil edin',
  'subscription.advancedReports': 'Təkmil hesabatlar',
  'subscription.applyCoupon': 'Tətbiq et',
  'subscription.autoRenewActive': '✅ Avtomatik yeniləmə aktivdir - Növbəti ödəniş:',
  'subscription.autoRenewBadge': '🔄 Avtomatik yenilənən abunəlik',
  'subscription.autoRenewInfo': '🔄 Abunəliyiniz avtomatik yenilənir. Yeniləmədən əvvəl e-poçt ilə bildiriş alacaqsınız.',
  'subscription.bankTransfer': 'Bank köçürməsi',
  'subscription.basicReports': 'Əsas hesabatlar',
  'subscription.billingAutoSave': '💾 Məlumatlarınız avtomatik yadda saxlanılır və növbəti ödənişinizdə doldurulur',
  'subscription.billingCycle': 'Ödəniş dövrü',
  'subscription.billingDesc': 'Hesab-faktura məlumatlarınızı daxil edin və ödəniş mərhələsinə keçin',
  'subscription.billingInfo': 'Hesab-faktura məlumatları',
  'subscription.billingInfoSaved': '✅ Hesab-faktura məlumatları yadda saxlanıldı',
  'subscription.billingLangLabel': 'Hesab-faktura dili',
  'subscription.billingPeriod': 'Hesab-faktura dövrü',
  'subscription.branchCashManagement': 'Filiala xas kassa idarəetməsi',
  'subscription.branchesIncluded': '2 filiala qədər daxildir',
  'subscription.buyNow': 'İndi al',
  'subscription.cancel': 'Abunəliyi ləğv et',
  'subscription.cancelAnytime': 'ℹ️ Abunəliyi istədiyiniz vaxt ləğv edə bilərsiniz.',
  'subscription.cancelConfirm': 'Abunəliyinizi ləğv etmək istədiyinizə əminsiniz? Xidmətiniz dövrün sonuna qədər davam edəcək.',
  'subscription.cancelFailed': 'Ləğv alınmadı',
  'subscription.cancelSubBtn': '❌ Abunəliyi ləğv et',
  'subscription.cancelSuccess': '✅ Abunəlik ləğv edildi. Xidmətiniz dövrün sonuna qədər davam edəcək.',
  'subscription.cardAtPayment': '💳 Ödəniş, ödəniş səhifəsində kart məlumatlarınızla həyata keçiriləcək.',
  'subscription.cardInfoTitle': 'Kart məlumatları ödəniş səhifəsində alınacaq',
  'subscription.cardNumber': 'Kart nömrəsi',
  'subscription.cardNumberPlaceholder': 'Kart nömrəsini daxil edin',
  'subscription.changePlan': '💳 Dəyiş',
  'subscription.changePlanIntl': '🏓 Dəyiş',
  'subscription.choosePlan': 'Plan seç',
  'subscription.companyName': 'Ünvan (rəsmi ad)',
  'subscription.companyNamePlaceholder': 'Şirkətin rəsmi adını daxil edin',
  'subscription.comparePlans': 'Planları müqayisə edin',
  'subscription.completePayment': 'Ödənişi tamamla',
  'subscription.contactSales': 'Satış şöbəsi ilə əlaqə',
  'subscription.contactSupport': 'Dəstəklə əlaqə',
  'subscription.corporateInvoice': 'Korporativ hesab-faktura',
  'subscription.couponCode': 'Kupon kodu',
  'subscription.couponRemoved': 'Kupon silindi',
  'subscription.couponVerificationFailed': 'Kupon təsdiqlənə bilmədi',
  'subscription.creditCard': 'Kredit kartı',
  'subscription.crossBranchDelivery': 'Filiallararası çatdırılma',
  'subscription.currentPlan': 'Cari planınız',
  'subscription.currentUsage': 'Cari istifadə',
  'subscription.customReports': 'Fərdi hesabatlar',
  'subscription.customersLabel': 'Müştərilər',
  'subscription.cvc': 'CVC',
  'subscription.daysLeft': 'gün qalıb',
  'subscription.discount': 'Endirim',
  'subscription.downgrade': 'Aşağı plana keç',
  'subscription.downgradePlan': 'Kiçilt',
  'subscription.driverApp': 'Mobil sürücü tətbiqi',
  'subscription.emailNotifBadge': '💳 Yeniləmədən əvvəl e-poçt bildirişi',
  'subscription.endDate': 'Bitmə tarixi',
  'subscription.enterBillingInfo': '📄 Zəhmət olmasa hesab-faktura məlumatlarınızı doldurun',
  'subscription.enterCompanyName': 'Rəsmi adı daxil edin',
  'subscription.enterPhone': 'Telefon nömrəsini daxil edin',
  'subscription.enterTaxNumber': 'VÖEN daxil edin',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Korporativ həllər',
  'subscription.enterpriseOnlyDesc': 'Filial idarəetməsi yalnız Enterprise planında mövcuddur. Bir neçə filialı idarə etmək, filiala xas kassa və filiallararası çatdırılma üçün Enterprise-a keçin.',
  'subscription.enterpriseOnlyTitle': 'Enterprise planı tələb olunur',
  'subscription.expired': 'Müddəti bitib',
  'subscription.expiredOn': 'Bitmə tarixi',
  'subscription.expiresOn': 'Bitir',
  'subscription.expiringDays': 'Abunəliyinizin müddəti {days} gün sonra bitəcək. Xidmətin fasiləsiz davam etməsi üçün zəhmət olmasa yeniləyin.',
  'subscription.expiryDate': 'Etibarlılıq müddəti',
  'subscription.expiryLabel': 'Etibarlılıq müddəti:',
  'subscription.extendBtn': 'Abunəliyi uzat',
  'subscription.extendSubBtn': '💳 Abunəliyi uzat',
  'subscription.extendedBy1m': '1 ay uzadılacaq',
  'subscription.extendedBy1y': '1 il uzadılacaq',
  'subscription.failedPaymentCards': '❌ UĞURSUZ ÖDƏNİŞ TEST KARTLARI:',
  'subscription.faq1a': 'Planı dəyişdiyiniz zaman yeni xüsusiyyətlərə dərhal giriş əldə edirsiniz. Aldığınız istifadə müddəti (aylıq və ya illik) mövcud müddətinizin üzərinə əlavə olunur.',
  'subscription.faq1q': 'Planı dəyişdikdə nə baş verir?',
  'subscription.faq2a': 'Abunəliyinizi ləğv etsəniz, cari dövrün sonuna qədər xidmət almağa davam edirsiniz. Məlumatlarınız 15 gün ərzində saxlanılır.',
  'subscription.faq2q': 'Ləğv etsəm nə olar?',
  'subscription.faq3a': 'Yalnız kredit kartı və bank kartı ilə ödəniş qəbul olunur. Bank köçürməsi ilə ödəniş edilə bilməz.',
  'subscription.faq3q': 'Hansı ödəniş üsullarını qəbul edirsiniz?',
  'subscription.faq4a': 'Hesab açıldıqdan sonra 15 gün ərzində bütün xüsusiyyətlərdən pulsuz istifadə edə bilərsiniz. Sınaq müddəti bitdikdə abunəlik almalısınız.',
  'subscription.faq4q': '15 günlük sınaq necə işləyir?',
  'subscription.faqTitle': 'Tez-tez verilən suallar',
  'subscription.features': 'Xüsusiyyətlər',
  'subscription.featuresIncluded': 'Xüsusiyyətlər:',
  'subscription.freeTrial': '{months} ay pulsuz',
  'subscription.individualInvoice': 'Fərdi hesab-faktura',
  'subscription.invalidCard': '📌 Etibarsız kart:',
  'subscription.invalidCoupon': 'Etibarsız kupon kodu',
  'subscription.liveMode': ' LIVE (Canlı mühit)',
  'subscription.loading': 'Abunəlik yüklənir...',
  'subscription.manageBilling': 'Hesab-faktura idarəetməsi',
  'subscription.managerApp': 'Mobil uyğun rəhbər ekranı',
  'subscription.maxReceipts': 'Maksimum {count} qəbz/ay',
  'subscription.maxUsers': '{count} istifadəçi hesabı',
  'subscription.month': 'ay',
  'subscription.monthly': 'Aylıq',
  'subscription.monthlyLimit': 'Aylıq limit',
  'subscription.mostPopular': 'Ən populyar',
  'subscription.noSubscription': 'Aktiv abunəlik yoxdur',
  'subscription.odealPOS': 'Ödeal POS inteqrasiyası (istəyə bağlı)',
  'subscription.paddleActive': 'Aktiv',
  'subscription.paddleApiNotConfigured': 'Paddle API açarı konfiqurasiya edilməyib. Zəhmət olmasa administratorunuzla əlaqə saxlayın.',
  'subscription.paddleConfigurationMissing': '⚠️ Paddle konfiqurasiyası çatışmır!',
  'subscription.paddleConfigured': '✅ Bəli',
  'subscription.paddleDashboardRequired': '⚠️ Paddle Dashboard konfiqurasiyası tələb olunur!',
  'subscription.paddleNotConfigured': '❌ Xeyr',
  'subscription.paddleNotLoaded': 'Paddle SDK hələ yüklənməyib. Zəhmət olmasa səhifəni yeniləyin.',
  'subscription.paddleTestCards': 'Test kartları konsola yazdırıldı! (F12)',
  'subscription.payNow': 'İndi ödə',
  'subscription.paymentCancelled': '❌ Ödəniş ləğv edildi.',
  'subscription.paymentCompleted': '🎉 Ödəniş uğurla tamamlandı!',
  'subscription.paymentCreationFailed': 'Ödəniş əməliyyatı yaradıla bilmədi. Zəhmət olmasa konsol loglarını yoxlayın.',
  'subscription.paymentError': 'Ödəniş xətası: ',
  'subscription.paymentMethod': 'Ödəniş üsulu',
  'subscription.paymentRequiredBadge': '💳 Yeniləmə üçün ödəniş tələb olunur',
  'subscription.paymentSuccess': '✅ Ödəniş uğurlu oldu! Abunəliyiniz aktivləşdirildi.',
  'subscription.paymentTitle': 'Ödənişi tamamla',
  'subscription.perMonth': '/ay',
  'subscription.perYear': '/il',
  'subscription.phone': 'Telefon',
  'subscription.phonePlaceholder': 'Telefon nömrəsini daxil edin',
  'subscription.plan': 'Plan',
  'subscription.planSelection': 'Seçilmiş plan',
  'subscription.planWord': 'planı',
  'subscription.plusVAT': '+ ƏDV',
  'subscription.popular': 'Populyar',
  'subscription.prioritySupport': 'Prioritet dəstək',
  'subscription.pro': 'Pro',
  'subscription.processing': 'Emal olunur...',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Böyüyən bizneslər üçün',
  'subscription.purchasePlanTitle': '{name} planının alınması',
  'subscription.receiptsLabel': 'Qəbzlər',
  'subscription.redirectingToPayment': 'Ödəniş səhifəsinə yönləndirilirsiniz...',
  'subscription.referralDesc': 'Dəvət etdiyin dostun qeydiyyatdan keçib üzv olduqda 1 ay əlavə müddət qazanırsan! Sadəcə dəvət göndərmək kifayət deyil.',
  'subscription.referralShare': 'Dəvət linkini paylaş',
  'subscription.referralTitle': 'Dostlarına tövsiyə et',
  'subscription.region.europe': '🇪🇺 Avropa',
  'subscription.region.other': '🌎 Digər',
  'subscription.region.turkey': '🇹🇷 Türkiyə',
  'subscription.removeCoupon': 'Sil',
  'subscription.renew': 'Abunəliyi yenilə',
  'subscription.renewNow': 'İndi yenilə',
  'subscription.renewsInDays': 'Cari abunəliyiniz {days} gün ərzində yenilənəcək',
  'subscription.sandboxMode': '🧪 SANDBOX (Test rejimi)',
  'subscription.sandboxOnly': '📝 QEYD: Bu kartlar yalnız Sandbox mühitində işləyir!',
  'subscription.sandboxTestCards': '🎴 TEST KARTLARI (SANDBOX)',
  'subscription.save': '%{percent} qənaət',
  'subscription.saveInfoBtn': '💾 Məlumatları yadda saxla',
  'subscription.saveInfoHint': 'Növbəti ödənişdə avtomatik doldurulacaq',
  'subscription.savedBillingInfo': '📄 Yadda saxlanılmış hesab-faktura məlumatlarınız',
  'subscription.selectBtn': 'Seç',
  'subscription.selectPackage': 'Zəhmət olmasa bir paket seçin',
  'subscription.selectPlan': 'Zəhmət olmasa bir plan seçin',
  'subscription.startDate': 'Başlama tarixi',
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Kiçik bizneslər üçün ideal',
  'subscription.status': 'Status',
  'subscription.subCancelledBadge': '⚠️ Abunəlik ləğv edildi',
  'subscription.subInfoTitle': '📋 Abunəlik məlumatları',
  'subscription.subIsMonthly': '✅ Bu, aylıq abunəlik əməliyyatıdır.',
  'subscription.subIsYearly': '✅ Bu, illik abunəlik əməliyyatıdır.',
  'subscription.subtitle': 'Planınızı idarə edin və hesab-faktura ayarlarınızı tənzimləyin',
  'subscription.subtotal': 'Aralıq cəm',
  'subscription.successfulPaymentCards': '✅ UĞURLU ÖDƏNİŞ TEST KARTLARI:',
  'subscription.supportTicket': 'Dəstək müraciətinə cavab müddəti: {hours} saat',
  'subscription.supportTicketBusiness': 'Dəstək müraciətinə cavab müddəti: {hours} saat (iş saatlarında)',
  'subscription.supportTimeLabel': 'Dəstək müraciəti müddəti',
  'subscription.switchPlan': '💳 Paketə keç',
  'subscription.switchPlanIntl': '🏓 Paketə keç',
  'subscription.tax': 'ƏDV (%{rate})',
  'subscription.taxNumber': 'VÖEN',
  'subscription.taxNumberPlaceholder': 'VÖEN daxil edin',
  'subscription.taxOffice': 'Vergi orqanı',
  'subscription.total': 'Cəmi',
  'subscription.totalAmountLabel': 'Ümumi məbləğ',
  'subscription.trial': 'Sınaq',
  'subscription.trial15d': '15 günlük sınaq',
  'subscription.trialDaysLeft': 'sınaq günü qalıb',
  'subscription.trialEnd': 'Sınaq bitir',
  'subscription.unlimitedUsers': 'Limitsiz istifadəçi',
  'subscription.upgrade': 'Yüksəlt',
  'subscription.upgradeBtn': 'Yüksəlt',
  'subscription.upgradePlan': 'Yüksəlt',
  'subscription.upgradeToEnterprise': 'Enterprise-a keç',
  'subscription.usageTitle': 'Bu ayın istifadəsi və limitlər',
  'subscription.usersLabel': 'İstifadəçilər',
  'subscription.vatNote': '+ ƏDV (%20)',
  'subscription.warning': 'Abunəlik xəbərdarlığı',
  'subscription.whatsappCredits': '🎁 {count} WhatsApp krediti hədiyyə',
  'subscription.whatsappCreditsAmount': '{count} kredit',
  'subscription.whatsappCreditsPackages': 'Kredit paketləri',
  'subscription.whatsappCreditsTitle': 'WhatsApp krediti',
  'subscription.whatsappCurrentBalance': 'Cari balans',
  'subscription.whatsappIntegration': 'WhatsApp inteqrasiyası',
  'subscription.whatsappPurchaseCredits': 'Kredit al',
  'subscription.year': 'il',
  'subscription.yearly': 'İllik',
  'subscription.yearlyFreeBtn': '🎉 İllik (2 ay pulsuz!)',
  'subscription.yearlyFreeNote': '🎉 İllik ödənişlə 2 ay pulsuz!',
  'subscription.yearlySavings': '💡 İllik ödənişlə %17 qənaət edin',
  'tailoring.add': 'Əlavə et',
  'tailoring.addCustom': 'Xüsusi əməliyyat əlavə et',
  'tailoring.addCustomHint': 'Xüsusi əməliyyat əlavə etmək üçün + düyməsindən istifadə edin',
  'tailoring.addNewDescription': 'Xüsusi dərzi əməliyyatı növü əlavə edin',
  'tailoring.addNewTitle': 'Yeni dərzi əməliyyatı əlavə et',
  'tailoring.addSuccess': 'Yeni dərzi əməliyyatı əlavə edildi!',
  'tailoring.astarDegisimi': 'Astarın dəyişdirilməsi',
  'tailoring.belAyarı': 'Belin tənzimlənməsi',
  'tailoring.cancel': 'Ləğv et',
  'tailoring.cepDikimi': 'Cib tikilməsi',
  'tailoring.default': 'Defolt',
  'tailoring.deleteConfirm': 'Bu dərzi əməliyyatını silmək istədiyinizə əminsiniz?',
  'tailoring.deleteError': 'Silmə xətası',
  'tailoring.deleteSuccess': 'Dərzi əməliyyatı silindi',
  'tailoring.dugmeDikme': 'Düymə tikilməsi',
  'tailoring.fermuarDegisimi': 'Fermuarın dəyişdirilməsi',
  'tailoring.icon': 'İkon',
  'tailoring.iconLabel': 'İkon (Emoji)',
  'tailoring.info1': 'Qiymətləri dəyişdikdən sonra "Qiymətləri yadda saxla" düyməsinə klikləyin',
  'tailoring.info2': '"Yeni əməliyyat" düyməsi ilə xüsusi dərzi əməliyyatı növləri əlavə edə bilərsiniz',
  'tailoring.info3': 'Əlavə etdiyiniz xüsusi əməliyyatları zibil qutusu ikonu ilə silə bilərsiniz',
  'tailoring.info4': 'Bu qiymətlər sifariş yaradılarkən dərzi xidməti seçildikdə istifadə olunur',
  'tailoring.info5': 'Hər dərzi əməliyyatı üçün ayrıca qiymət təyin edə bilərsiniz',
  'tailoring.info6': 'Qiymətlər müştəri səbətinə əlavə edilərkən avtomatik hesablanır',
  'tailoring.infoTitle': 'Məlumat',
  'tailoring.invalidPrice': 'Etibarlı qiymət daxil edin',
  'tailoring.kolBoyu': 'Qol uzunluğu',
  'tailoring.loadError': 'Qiymətlər yüklənə bilmədi',
  'tailoring.nameRequired': 'Əməliyyat adını daxil edin',
  'tailoring.omuzAyarı': 'Çiyin tənzimlənməsi',
  'tailoring.operationName': 'Əməliyyatın adı',
  'tailoring.operationNameLabel': 'Əməliyyatın adı',
  'tailoring.operationNamePlaceholder': 'Məs: Xüsusi tikiş',
  'tailoring.pacaBoyu': 'Qoltuq tikişi',
  'tailoring.price': 'Qiymət',
  'tailoring.priceLabel': 'Qiymət',
  'tailoring.save': 'Yadda saxla',
  'tailoring.saveError': 'Yadda saxlama xətası',
  'tailoring.savePrices': 'Qiymətləri yadda saxla',
  'tailoring.savePricesHint': 'Qiymətləri yadda saxlamaq üçün Yadda saxla düyməsinə klikləyin',
  'tailoring.saveSuccess': 'Dərzi qiymətləri yadda saxlanıldı!',
  'tailoring.sokukDikimi': 'Söküyün tikilməsi',
  'tailoring.subtitle': 'Dərzi əməliyyatlarının qiymətlərini buradan yeniləyə bilərsiniz',
  'tailoring.yama': 'Yamaq',
  'tickets.admin': 'Administrator',
  'tickets.closedMessage': 'Bu dəstək müraciəti bağlanıb.',
  'tickets.conversation': 'Yazışma',
  'tickets.createError': 'Dəstək müraciəti yaradıla bilmədi',
  'tickets.created': 'Dəstək müraciəti yaradıldı',
  'tickets.descriptionPlaceholder': 'Probleminizi ətraflı izah edin...',
  'tickets.fillAllFields': 'Zəhmət olmasa bütün sahələri doldurun',
  'tickets.loadError': 'Dəstək müraciətləri yüklənə bilmədi',
  'tickets.messages': 'Mesajlar',
  'tickets.noTicketsDesc': 'Hələ dəstək müraciətiniz yoxdur',
  'tickets.rateDescription': 'Dəstək təcrübənizi qiymətləndirin',
  'tickets.rateExperience': 'Təcrübənizi qiymətləndirin',
  'tickets.rateSupport': 'Dəstək balı',
  'tickets.rating.bad': 'Pis',
  'tickets.rating.excellent': 'Əla',
  'tickets.rating.good': 'Yaxşı',
  'tickets.rating.okay': 'Orta',
  'tickets.rating.veryBad': 'Çox pis',
  'tickets.ratingError': 'Qiymətləndirmə yadda saxlanıla bilmədi',
  'tickets.ratingSubmitted': 'Balınız yadda saxlanıldı, təşəkkür edirik!',
  'tickets.selectRating': 'Bal seçin',
  'tickets.sendError': 'Mesaj göndərilə bilmədi',
  'tickets.status.closed': 'Bağlı',
  'tickets.status.investigating': 'Araşdırılır',
  'tickets.status.open': 'Açıq',
  'tickets.status.waitingCustomer': 'Müştəri gözlənilir',
  'tickets.subjectPlaceholder': 'Dəstək mövzusu...',
  'tickets.translationError': 'Tərcümə xətası',
  'tickets.yourName': 'Adınız',
  'tickets.yourNamePlaceholder': 'Adınızı daxil edin...',
  'tickets.yourRating': 'Balınız',
  'toast.cardPaymentFailed': 'Ödəniş uğursuz oldu. Zəhmət olmasa yenidən cəhd edin.',
  'toast.cardPaymentSuccessMsg': 'Kart ödənişi uğurlu oldu!',
  'toast.connectionError': 'Bağlantı yadda saxlanıla bilmədi',
  'toast.connectionStatusError': 'Bağlantı statusu yüklənə bilmədi',
  'toast.customerAdded': 'Müştəri əlavə edildi',
  'toast.customerError': 'Müştəri əlavə edilə bilmədi',
  'toast.customerExistingSelected': 'Mövcud müştəri seçildi',
  'toast.customerPhoneNotFound': 'Müştərinin telefonu tapılmadı',
  'toast.deliveryDatePastError': 'Təhvil tarixi bu gündən əvvəl ola bilməz',
  'toast.demoCustomersKept': '{n} nümunə müştərinin sizin kəsdiyiniz qəbzi olduğu üçün kartı saxlanıldı; yalnız nümunə qəbzləri silindi.',
  'toast.demoDataDeleteError': 'Demo məlumatları silinə bilmədi',
  'toast.demoDataDeleted': 'Demo məlumatları silindi',
  'toast.disconnectError': 'Bağlantı kəsilə bilmədi',
  'toast.editCancelled': 'Redaktə ləğv edildi',
  'toast.logoTooLarge': 'Loqo faylı çox böyükdür',
  'toast.logoUploadError': 'Loqo yüklənə bilmədi',
  'toast.noDemoData': 'Silinəcək nümunə müştəri tapılmadı.',
  'toast.noEditPermission': 'Redaktə icazəniz yoxdur',
  'toast.orderCreated': 'Sifariş yaradıldı',
  'toast.orderDetailsLoadError': 'Sifariş təfərrüatları yüklənə bilmədi',
  'toast.orderError': 'Sifariş yaradıla bilmədi',
  'toast.orderLoadError': 'Sifariş yüklənə bilmədi',
  'toast.orderNotFound': 'Sifariş tapılmadı',
  'toast.orderStatusUpdateError': 'Sifariş statusunu yeniləmək alınmadı',
  'toast.orderStatusUpdated': 'Sifariş statusu yeniləndi',
  'toast.orderUpdateError': 'Sifariş yenilənə bilmədi',
  'toast.paymentFailedTryAgain': 'Ödəniş uğursuz oldu, zəhmət olmasa yenidən cəhd edin',
  'toast.paymentStatusCheckErrorShort': 'Ödəniş statusu yoxlanıla bilmədi.',
  'toast.pinChangeError': 'PIN kod dəyişdirilə bilmədi',
  'toast.pinChanged': 'PIN kod dəyişdirildi',
  'toast.productAddedSimple': 'Məhsul əlavə edildi',
  'toast.productError': 'Məhsul əlavə edilə bilmədi',
  'toast.qrError': 'QR kod yaradıla bilmədi',
  'toast.qrGenerated': 'QR kod yaradıldı. Zəhmət olmasa WhatsApp Business tətbiqiniz ilə skan edin.',
  'toast.searchError': 'Axtarış xətası',
  'toast.statsError': 'Statistika yüklənə bilmədi',
  'toast.uploadingLogo': 'Loqo yüklənir...',
  'toast.userAddError': 'İstifadəçi əlavə edilə bilmədi',
  'toast.userAdded': 'İstifadəçi əlavə edildi',
  'toast.userDeleteError': 'İstifadəçi silinə bilmədi',
  'toast.userDeleted': 'İstifadəçi uğurla silindi/deaktiv edildi',
  'toast.userUpdateError': 'İstifadəçi yenilənə bilmədi',
  'toast.userUpdated': 'İstifadəçi yeniləndi',
  'toast.usersLoadError': 'İstifadəçilər yüklənə bilmədi',
  'toast.whatsappConnected': 'WhatsApp Business uğurla qoşuldu!',
  'toast.whatsappDisconnected': 'WhatsApp Business bağlantısı kəsildi',
  'toast.whatsappFailed': 'WhatsApp göndərilə bilmədi',
  'toast.whatsappSent': 'WhatsApp göndərildi',
  'update': 'Yenilə',
  'users.delete': 'Sil',
  'users.deleteError': 'İstifadəçini silmək alınmadı',
  'users.deleteUserTitle': 'İstifadəçini sil',
  'users.deletingUser': '{name} istifadəçisini silmək istədiyinizə əminsiniz?',
  'users.eleman': 'İşçi',
  'users.loadError': 'İstifadəçiləri yükləmək alınmadı',
  'users.userDeleteError': 'İstifadəçini silmək alınmadı',
  'users.userDeleted': 'İstifadəçi uğurla silindi',
  'whatsapp.buyCredits': 'Kredit al',
  'whatsapp.connect': 'WhatsApp-ı qoş',
  'whatsapp.connected': 'Qoşulub',
  'whatsapp.creditPackages': 'Kredit paketləri',
  'whatsapp.credits': 'Kreditlər',
  'whatsapp.creditsRemaining': 'kredit qalıb',
  'whatsapp.disconnect': 'Bağlantını kəs',
  'whatsapp.messageHistory': 'Mesaj tarixçəsi',
  'whatsapp.messages': 'mesaj',
  'whatsapp.noCredits': 'Kredit qalmayıb',
  'whatsapp.orderDelivered': 'Sifariş təhvil verildi',
  'whatsapp.preview': 'Önizləmə',
  'whatsapp.receiptCreated': 'Qəbz yaradıldı',
  'whatsapp.save': 'Şablonu yadda saxla',
  'whatsapp.saved': 'Şablon yadda saxlanıldı',
  'whatsapp.scanQR': 'QR kodu skan et',
  'whatsapp.sendTest': 'Test mesajı göndər',
  'whatsapp.status': 'Status',
  'whatsapp.template': 'Şablon',
  'whatsapp.templates': 'Mesaj şablonları',
  'whatsapp.testFailed': 'Test mesajı göndərilə bilmədi',
  'whatsapp.testSent': 'Test mesajı göndərildi',
  'zReport.account': 'Cari hesab',
  'zReport.accountCollections': 'Cari hesab yığımları',
  'zReport.bankTransfer': 'Bank köçürməsi',
  'zReport.branchCollectionsNote': 'Öz + digər filial yığımı',
  'zReport.byEmployee': 'İşçiyə görə',
  'zReport.byProduct': 'Məhsula görə',
  'zReport.byService': 'Xidmətə görə',
  'zReport.cancelledOrders': 'Ləğv edilmiş sifariş',
  'zReport.cancelledReceipts': 'Ləğv edilmiş qəbzlər',
  'zReport.cardPayments': 'Kart ödənişləri',
  'zReport.cariCollection': 'Cari hesab yığımı',
  'zReport.cash': 'Nağd',
  'zReport.cashBoxStartNote': 'Kassanın başlanğıc məbləği',
  'zReport.cashCalculation': '(Başlanğıc + Bugünkü nağd - Xərclər)',
  'zReport.cashIn': 'Kassaya daxilolma',
  'zReport.cashOut': 'Kassadan məxaric',
  'zReport.cashPayments': 'Nağd ödənişlər',
  'zReport.cashRegister': 'Kassa hesabı',
  'zReport.cashToDeliver': 'Təhvil veriləcək nağd',
  'zReport.closingBalance': 'Bağlanış balansı',
  'zReport.collectedItems': 'Ödənişi yığılanlar',
  'zReport.collectionDetails': 'Yığım təfərrüatı',
  'zReport.creditCard': 'Kredit kartı',
  'zReport.creditPayments': 'Nisyə ödənişlər',
  'zReport.custom': 'Fərdi',
  'zReport.daily': 'Gündəlik',
  'zReport.dailyCashIncome': 'Gündəlik nağd gəlir',
  'zReport.dailyExpensesNote': 'Bugünkü xərclər',
  'zReport.dateRange': 'Tarix aralığı',
  'zReport.deliveryCard': 'Təhvildə alınan kredit kartı',
  'zReport.deliveryCash': 'Təhvildə alınan nağd',
  'zReport.discountNotReflected': 'Məbləğlər endirim tətbiq edilmiş xalis qiymətlər əsasında hesablanır.',
  'zReport.endDate': 'Bitmə',
  'zReport.excelDownloaded': 'Excel faylı yükləndi',
  'zReport.excelError': 'Excel faylı yaradıla bilmədi',
  'zReport.expenses': 'Xərclər',
  'zReport.free': 'Ödənişsiz',
  'zReport.freeOrders': 'Ödənişsiz sifarişlər',
  'zReport.generateReport': 'Hesabat yarat',
  'zReport.incoming': 'Daxil olan',
  'zReport.infoNote': 'Məlumat məqsədlidir',
  'zReport.loadError': 'Hesabat yüklənə bilmədi',
  'zReport.loading': 'Yüklənir...',
  'zReport.mealCard': 'Yemək kartı',
  'zReport.monthly': 'Aylıq',
  'zReport.newCustomers': 'Yeni müştərilər',
  'zReport.noCancelled': 'Ləğv edilmiş qəbz yoxdur',
  'zReport.noData': 'Bu dövr üçün məlumat yoxdur',
  'zReport.noExpenses': 'Xərc qeydi yoxdur',
  'zReport.onDelivery': 'Təhvildə ödəniş',
  'zReport.openingBalance': 'Açılış balansı',
  'zReport.orderCollections': 'Sifariş yığımları',
  'zReport.orderPaidAtDelivery': 'Təhvildə ödənilən sifariş',
  'zReport.orderPaidAtRegister': 'Qeydiyyatda ödənilən sifariş',
  'zReport.outgoing': 'Çıxan',
  'zReport.paidAtDelivery': 'Təhvildə ödənilən',
  'zReport.paidAtRegister': 'Qeydiyyatda ödənilən',
  'zReport.paymentDetails': 'Yığım təfərrüatı',
  'zReport.paymentMethods': 'Ödəniş üsulları',
  'zReport.period': 'Dövr',
  'zReport.printReport': 'Hesabatı çap et',
  'zReport.reason': 'Səbəb',
  'zReport.registrationAndDelivery': 'Qeydiyyat + Təhvil',
  'zReport.returningCustomers': 'Qayıdan müştərilər',
  'zReport.selectDate': 'Tarix seç',
  'zReport.serviceBreakdown': 'Xidmətlər üzrə əşya sayı (daxilolmalar)',
  'zReport.singleDay': 'Tək gün',
  'zReport.startDate': 'Başlanğıc',
  'zReport.startingCash': 'Başlanğıc pulu',
  'zReport.title': 'Z hesabatı',
  'zReport.todayCashNote': 'Bu gün alınan nağd',
  'zReport.todayRegistrations': 'Bugünkü qeydiyyatlar',
  'zReport.totalCancelled': 'Cəmi ləğv ({count} qəbz)',
  'zReport.totalCollected': 'Cəmi yığılıb',
  'zReport.totalCollection': 'Cəmi yığım',
  'zReport.totalExpenses': 'Cəmi xərc',
  'zReport.totalItems': 'Cəmi əşya',
  'zReport.totalOrders': 'Cəmi sifariş',
  'zReport.totalRefunds': 'Cəmi geri qaytarmalar',
  'zReport.totalRegistered': 'Qeydə alınan cəmi',
  'zReport.totalRevenue': 'Cəmi dövriyyə',
  'zReport.totalSales': 'Cəmi satış',
  'zReport.transferPayments': 'Köçürmə ödənişləri',
  'zReport.weekly': 'Həftəlik',
  'zreport.card': 'Kart',
  'zreport.cash': 'Nağd',
  'zreport.date': 'Tarix',
  'zreport.orders': 'Sifarişlər',
  'zreport.print': 'Çap et',
  'zreport.title': 'Z hesabatı',
  'zreport.total': 'Cəmi',
  'zReport.todayOrders': 'Bugünkü sifarişlər',
};
